export default {
  '(自定义)': '(自定义)',
  '0.15-0.6 双贡针': '0.15-0.6 双贡针',
  '0.15-0.9 双贡针': '0.15-0.9 双贡针',
  '0.15-0.9cm 双贡针': '0.15-0.9cm 双贡针',
  '0.15cm 贡针': '0.15cm 贡针',
  '0.3cm 贡针': '0.3cm 贡针',
  '0.6cm 贡针': '0.6cm 贡针',
  '0.9cm 贡针': '0.9cm 贡针',
  '1 个平叠锁眼 + 1 纽扣': '1 个平叠锁眼 + 1 纽扣',
  '1 个平斜锁眼 + 1 纽扣': '1 个平斜锁眼 + 1 纽扣',
  '1 个平斜锁眼+1 纽扣': '1 个平斜锁眼+1 纽扣',
  '1 个平锁眼 + 1 纽扣': '1 个平锁眼 + 1 纽扣',
  '1 个斜叠锁眼 + 1 纽扣': '1 个斜叠锁眼 + 1 纽扣',
  '2 个平叠锁眼 + 2 纽扣': '2 个平叠锁眼 + 2 纽扣',
  '2 个平斜锁眼 + 2 纽扣': '2 个平斜锁眼 + 2 纽扣',
  '2 个平斜锁眼+2 纽扣': '2 个平斜锁眼+2 纽扣',
  '2 个平锁眼 + 2 纽扣': '2 个平锁眼 + 2 纽扣',
  '2 个斜叠锁眼 + 2 纽扣': '2 个斜叠锁眼 + 2 纽扣',
  '2 件套': '2 件套',
  '2 次代用料毛样': '2 次代用料毛样',
  '2件套': '2件套',
  '2次代用料': '2次代用料',
  '3 个平叠锁眼+3 纽扣': '3 个平叠锁眼+3 纽扣',
  '3 个平斜锁眼+3 纽扣': '3 个平斜锁眼+3 纽扣',
  '3 个平锁眼 + 3 纽扣': '3 个平锁眼 + 3 纽扣',
  '3 个平锁眼+3 纽扣': '3 个平锁眼+3 纽扣',
  '3 个斜叠锁眼+3 纽扣': '3 个斜叠锁眼+3 纽扣',
  '3 个贴袋': '3 个贴袋',
  '3 件套': '3 件套',
  '3件套': '3件套',
  '3粒': '3粒',
  '4 个平叠锁眼+4 纽扣': '4 个平叠锁眼+4 纽扣',
  '4 个平斜锁眼+4 纽扣': '4 个平斜锁眼+4 纽扣',
  '4 个平锁眼 + 4 纽扣': '4 个平锁眼 + 4 纽扣',
  '4 个平锁眼+4 纽扣': '4 个平锁眼+4 纽扣',
  '4 个斜叠锁眼+4 纽扣': '4 个斜叠锁眼+4 纽扣',
  '5 个平叠锁眼+5 纽扣': '5 个平叠锁眼+5 纽扣',
  '5 个平斜锁眼+5 纽扣': '5 个平斜锁眼+5 纽扣',
  '5 个平锁眼 + 5 纽扣': '5 个平锁眼 + 5 纽扣',
  '5 个平锁眼+5 纽扣': '5 个平锁眼+5 纽扣',
  '5 个斜叠锁眼+5 纽扣': '5 个斜叠锁眼+5 纽扣',
  '5.5cm 袋盖': '5.5cm 袋盖',
  '5粒': '5粒',
  '6 个平叠锁眼+6 纽扣': '6 个平叠锁眼+6 纽扣',
  '6 个平斜锁眼+6 纽扣': '6 个平斜锁眼+6 纽扣',
  '6 个平锁眼 + 6 纽扣': '6 个平锁眼 + 6 纽扣',
  '6 个平锁眼+6 纽扣': '6 个平锁眼+6 纽扣',
  '6 个斜叠锁眼+6 纽扣': '6 个斜叠锁眼+6 纽扣',
  '6.5cm 袋盖': '6.5cm 袋盖',
  '6粒': '6粒',
  '7.5cm 袋盖': '7.5cm 袋盖',
  '8.5cm 袋盖': '8.5cm 袋盖',
  'AI 校验建议': 'AI 校验建议',
  'AI 正面': 'AI 正面',
  'AI 渲染预览': 'AI 渲染预览',
  '生成AI预览图': '生成AI预览图',
  '正在生成中...': '正在生成中...',
  'AI 生成最终款式图': 'AI 生成最终款式图',
  'AI校验功能开发中': 'AI校验功能开发中',
  'AI生成款式图（正面）': 'AI生成款式图（正面）',
  'API 配置': 'API 配置',
  'A字裙': 'A字裙',
  'B端门店订单管理系统': 'B端门店订单管理系统',
  'CM': 'CM',
  'CMT工艺费（USD）': 'CMT工艺费（USD）',
  'FT': 'FT',
  'IP 地址': 'IP 地址',
  'KG': 'KG',
  'LB': 'LB',
  'LOGO': 'LOGO',
  'Logo上传成功': 'Logo上传成功',
  'POLO 门襟 3.5cm（门襟 3 扣）': 'POLO 门襟 3.5cm（门襟 3 扣）',
  'POLO 门襟 3cm（门襟 3 扣）': 'POLO 门襟 3cm（门襟 3 扣）',
  'RTW成衣': 'RTW成衣',
  'RTW成衣价格表': 'RTW成衣价格表',
  'V 型开口': 'V 型开口',
  'V 领': 'V 领',
  'YYYY-MM-DD': 'YYYY-MM-DD',
  'YYYY-MM-DD HH:mm': 'YYYY-MM-DD HH:mm',
  'YYYY/M/D': 'YYYY/M/D',
  'ai建议': 'ai建议',
  '— CM': '— CM',
  '— KG': '— KG',
  '⚠️ 折扣低于审批红线': '⚠️ 折扣低于审批红线',
  '、': '、',
  '一字半里（包边）': '一字半里（包边）',
  '一字半里（贡针）': '一字半里（贡针）',
  '一字胸袋+下单开线袋': '一字胸袋+下单开线袋',
  '一字胸袋+下双开线袋': '一字胸袋+下双开线袋',
  '一字胸袋+下贴袋': '一字胸袋+下贴袋',
  '一字领（外弧 CUTAWAY）': '一字领（外弧 CUTAWAY）',
  '一片领': '一片领',
  '一金（住房公积金）': '一金（住房公积金）',
  '三件套西装': '三件套西装',
  '三步完成客户量体订单': '三步完成客户量体订单',
  '上一字胸袋+下双线袋有袋盖': '上一字胸袋+下双线袋有袋盖',
  '上一步': '上一步',
  '上下都无口袋': '上下都无口袋',
  '上传': '上传',
  '上传Logo': '上传Logo',
  '上传体型照': '上传体型照',
  '上传凭证': '上传凭证',
  '上传功能开发中': '上传功能开发中',
  '上传图片': '上传图片',
  '上传失败': '上传失败',
  '上传失败，请检查网络': '上传失败，请检查网络',
  '上左右一字袋+下左右一字袋': '上左右一字袋+下左右一字袋',
  '上弧形': '上弧形',
  '上衣 + 马甲': '上衣 + 马甲',
  '上衣+马甲': '上衣+马甲',
  '上衣尺寸': '上衣尺寸',
  '上衣设计': '上衣设计',
  '上衣设计尺寸': '上衣设计尺寸',
  '上衣部位': '上衣部位',
  '上衣长短习惯': '上衣长短习惯',
  '下一步': '下一步',
  '下单': '下单',
  '下单日期': '下单日期',
  '下单日期从': '下单日期从',
  '下单日期到': '下单日期到',
  '完成日期从': '完成日期从',
  '完成日期到': '完成日期到',
  '下单日期（B 端）': '下单日期（B 端）',
  '下口袋袋盖高度': '下口袋袋盖高度',
  '下圆青果领': '下圆青果领',
  '下弧形': '下弧形',
  '下摆型': '下摆型',
  '下载': '下载',
  '不可拆卸插片': '不可拆卸插片',
  '不合格原因': '不合格原因',
  '不合格数量': '不合格数量',
  '不是图片文件': '不是图片文件',
  '不试身': '不试身',
  '专业能力': '专业能力',
  '业务员': '业务员',
  '业务经理': '业务经理',
  '两件套西装': '两件套西装',
  '两次输入的密码不一致': '两次输入的密码不一致',
  '个人信息': '个人信息',
  '个人分红': '个人分红',
  '个人所得税': '个人所得税',
  '个人提成阶梯': '个人提成阶梯',
  '个人资料': '个人资料',
  '个性收费': '个性收费',
  '个性收费合计': '个性收费合计',
  '个性收费项配置': '个性收费项配置',
  '个选项': '个选项',
  '个面料': '个面料',
  '中圆青果领': '中圆青果领',
  '中文': '中文',
  '中腰': '中腰',
  '中英双语': '中英双语',
  '中长款': '中长款',
  '中长裙': '中长裙',
  '主题': '主题',
  '争议处理': '争议处理',
  '事事如意': '事事如意',
  '五险（保险）': '五险（保险）',
  '亚麻': '亚麻',
  '亚麻系列': '亚麻系列',
  '交易日期': '交易日期',
  '产品': '产品',
  '人民币参考': '人民币参考',
  '仅复用客户信息': '仅复用客户信息',
  '仅复用款式': '仅复用款式',
  '今日新增订单': '今日新增订单',
  '从样衣库中选择已有款式，一键下单': '从样衣库中选择已有款式，一键下单',
  '付款': '付款',
  '付款信息': '付款信息',
  '付款审核': '付款审核',
  '付款审核中': '付款审核中',
  '付款已确认': '付款已确认',
  '付款异常': '付款异常',
  '付款方式': '付款方式',
  '付款日期': '付款日期',
  '付款状态': '付款状态',
  '付款记录': '付款记录',
  '代理': '代理',
  '代用料手工毛样': '代用料手工毛样',
  '代用料毛样': '代用料毛样',
  '代采购': '代采购',
  '以下品类尚未选择面料：': '以下品类尚未选择面料：',
  '以下设计项尚未选择：': '以下设计项尚未选择：',
  '价格': '价格',
  '价格体系': '价格体系',
  '价格如有变动，恕不另行通知。': '价格如有变动，恕不另行通知。',
  '价格档': '价格档',
  '价格档次': '价格档次',
  '价格等级表': '价格等级表',
  '价格说明': '价格说明',
  '优先 10天': '优先 10天',
  '优先10天': '优先10天',
  '优先级': '优先级',
  '优先（10 天）': '优先（10 天）',
  '优惠活动': '优惠活动',
  '伸缩调节袢纽扣': '伸缩调节袢纽扣',
  '位置': '位置',
  '低腰': '低腰',
  '住房公积金': '住房公积金',
  '体型照': '体型照',
  '体型及尺寸档案': '体型及尺寸档案',
  '体型和款式图': '体型和款式图',
  '体型描述': '体型描述',
  '体型照/特殊设计照': '体型照/特殊设计照',
  '体型照片已匹配': '体型照片已匹配',
  '体型特征': '体型特征',
  '体型特征分析': '体型特征分析',
  '体重': '体重',
  '体重(kg)': '体重(kg)',
  '体重超出正常范围，请检查修改。': '体重超出正常范围，请检查修改。',
  '余款须在发货前结清。': '余款须在发货前结清。',
  '例如：退货、换货、维修': '例如：退货、换货、维修',
  '供应商': '供应商',
  '供应商对账单': '供应商对账单',
  '侧伸缩腰': '侧伸缩腰',
  '侧开叉': '侧开叉',
  '侧松紧腰': '侧松紧腰',
  '侧缝顺色哑光色丁 1.5cm': '侧缝顺色哑光色丁 1.5cm',
  '侧缝顺色哑光色丁 2.5cm': '侧缝顺色哑光色丁 2.5cm',
  '侧缝黑色哑光色丁 1.5cm': '侧缝黑色哑光色丁 1.5cm',
  '侧缝黑色哑光色丁 2.5cm': '侧缝黑色哑光色丁 2.5cm',
  '侧面': '侧面',
  '保存': '保存',
  '保存修改': '保存修改',
  '保存成功': '保存成功',
  '信息已更新（演示）': '信息已更新（演示）',
  '信用额度': '信用额度',
  '信用额度管理': '信用额度管理',
  '修改密码': '修改密码',
  '修改费': '修改费',
  '修身': '修身',
  '倒缝袖（垫肩 0.1cm + 单层棉条 + 自然褶）': '倒缝袖（垫肩 0.1cm + 单层棉条 + 自然褶）',
  '倒缝袖（无垫肩 + 无棉条 + 自然褶）': '倒缝袖（无垫肩 + 无棉条 + 自然褶）',
  '假袖叉假锁眼': '假袖叉假锁眼',
  '假袖叉圆头锁眼': '假袖叉圆头锁眼',
  '假袖叉圆弧翻边（4.5cm）': '假袖叉圆弧翻边（4.5cm）',
  '假袖叉圆弧翻边（7.5cm）': '假袖叉圆弧翻边（7.5cm）',
  '假袖叉无锁眼': '假袖叉无锁眼',
  '假袖叉直翻边（4.5cm）': '假袖叉直翻边（4.5cm）',
  '假袖叉直翻边（7.5cm）': '假袖叉直翻边（7.5cm）',
  '停用': '停用',
  '催款通知': '催款通知',
  '充值': '充值',
  '充值 / 退款金额': '充值 / 退款金额',
  '充值记录': '充值记录',
  '光门襟 3.5cm': '光门襟 3.5cm',
  '光门襟 3cm': '光门襟 3cm',
  '克重': '克重',
  '免熨系列': '免熨系列',
  '免费系列': '免费系列',
  '入门档': '入门档',
  '全体员工总权重': '全体员工总权重',
  '全勤': '全勤',
  '全手工': '全手工',
  '全手工全麻衬厚胸衬': '全手工全麻衬厚胸衬',
  '全手工全麻衬薄胸衬': '全手工全麻衬薄胸衬',
  '全松紧腰': '全松紧腰',
  '全松紧（前门襟无松紧）': '全松紧（前门襟无松紧）',
  '全衬': '全衬',
  '全裤袢 10 个 1cm': '全裤袢 10 个 1cm',
  '全裤袢 2cm': '全裤袢 2cm',
  '全裤袢 6 个 1cm': '全裤袢 6 个 1cm',
  '全裤袢 7 个 1cm': '全裤袢 7 个 1cm',
  '全裤袢 8 个 1cm': '全裤袢 8 个 1cm',
  '全贡针': '全贡针',
  '全部': '全部',
  '全部信息': '全部信息',
  '全部完成': '全部完成',
  '全部订单': '全部订单',
  '全里': '全里',
  '全麻衬厚胸衬': '全麻衬厚胸衬',
  '全麻衬薄胸衬': '全麻衬薄胸衬',
  '公司仓库': '公司仓库',
  '公告': '公告',
  '共享数据': '共享数据',
  '关税': '关税',
  '关联单号': '关联单号',
  '关联工厂': '关联工厂',
  '关闭': '关闭',
  '其他': '其他',
  '其他奖金': '其他奖金',
  '其他成员团单合计': '其他成员团单合计',
  '其他成员定制单合计': '其他成员定制单合计',
  '其他扣款': '其他扣款',
  '其他费用': '其他费用',
  '其它费用': '其它费用',
  '内容': '内容',
  '内折 5cm': '内折 5cm',
  '内折 7cm': '内折 7cm',
  '内滚条': '内滚条',
  '内袋款式': '内袋款式',
  '内袖口撞色': '内袖口撞色',
  '内贡针及贡针线': '内贡针及贡针线',
  '内过肩撞色': '内过肩撞色',
  '内门襟撞色': '内门襟撞色',
  '内领+内袖口+内门襟撞色': '内领+内袖口+内门襟撞色',
  '内领+内袖口撞色': '内领+内袖口撞色',
  '内领底居中': '内领底居中',
  '内领撞色': '内领撞色',
  '冬季': '冬季',
  '净尺寸': '净尺寸',
  '准直胸袋': '准直胸袋',
  '减少': '减少',
  '减少品类信息将丢失': '减少品类信息将丢失',
  '减少品类将丢失该品类的设计信息': '减少品类将丢失该品类的设计信息',
  '凭证号': '凭证号',
  '凭证截图': '凭证截图',
  '出生日期': '出生日期',
  '出货日期': '出货日期',
  '出货期': '出货期',
  '出货通知': '出货通知',
  '分红年份': '分红年份',
  '分红池比例': '分红池比例',
  '切角 1 眼 2 扣': '切角 1 眼 2 扣',
  '切角 2 用': '切角 2 用',
  '切角 2 眼 2 扣': '切角 2 眼 2 扣',
  '创建失败': '创建失败',
  '创建新订单': '创建新订单',
  '创建时间': '创建时间',
  '创建订单失败': '创建订单失败',
  '删除': '删除',
  '删除此刺绣': '删除此刺绣',
  '刷新': '刷新',
  '刷新页面': '刷新页面',
  '刺绣': '刺绣',
  '刺绣位置': '刺绣位置',
  '刺绣内容': '刺绣内容',
  '刺绣备注': '刺绣备注',
  '刺绣姓名缩写': '刺绣姓名缩写',
  '刺绣字体': '刺绣字体',
  '刺绣类型': '刺绣类型',
  '刺绣设计': '刺绣设计',
  '刺绣高度': '刺绣高度',
  '前后全里': '前后全里',
  '前后半里': '前后半里',
  '前挺缝线': '前挺缝线',
  '前浪': '前浪',
  '前片全里': '前片全里',
  '前片半里': '前片半里',
  '前片设计': '前片设计',
  '前片贴布': '前片贴布',
  '前端分类项配置': '前端分类项配置',
  '前胸宽': '前胸宽',
  '前腰节': '前腰节',
  '前腰节长': '前腰节长',
  '前长': '前长',
  '前领 1 个纽扣': '前领 1 个纽扣',
  '前领 2 个纽扣': '前领 2 个纽扣',
  '剪刀型': '剪刀型',
  '加入购物车': '加入购物车',
  '加急': '加急',
  '加急 5天': '加急 5天',
  '加急 7天': '加急 7天',
  '加急5天': '加急5天',
  '加急3天': '加急3天',
  '加急7天': '加急7天',
  '加急单': '加急单',
  '加急单数量': '加急单数量',
  '加急处理，确保15日前到达上海办公室。': '加急处理，确保15日前到达上海办公室。',
  '加急费': '加急费',
  '加急（7 天）': '加急（7 天）',
  '加载中…': '加载中…',
  '加载设计项...': '加载设计项...',
  '包装升级': '包装升级',
  '千克': '千克',
  '半圆形半里（包边）': '半圆形半里（包边）',
  '半圆形半里（贡针）': '半圆形半里（贡针）',
  '半手工半麻衬厚胸衬': '半手工半麻衬厚胸衬',
  '半手工半麻衬薄胸衬': '半手工半麻衬薄胸衬',
  '半手工无结构无胸衬': '半手工无结构无胸衬',
  '半衬': '半衬',
  '半贡针': '半贡针',
  '常规里袋+水滴笔袋': '常规里袋+水滴笔袋',
  '常规里袋+一字笔袋': '常规里袋+一字笔袋',
  '常规里袋+一字笔袋+卡袋': '常规里袋+一字笔袋+卡袋',
  '常规里袋+水滴笔袋+卡袋': '常规里袋+水滴笔袋+卡袋',
  '半身裙': '半身裙',
  '半麻衬厚胸衬': '半麻衬厚胸衬',
  '半麻衬薄胸衬': '半麻衬薄胸衬',
  '单 6 扣': '单 6 扣',
  '单上衣': '单上衣',
  '单价': '单价',
  '单价（USD）': '单价（USD）',
  '单位': '单位',
  '单大衣': '单大衣',
  '单开线竖口袋': '单开线竖口袋',
  '单开线袋+锁眼钉扣': '单开线袋+锁眼钉扣',
  '单开线袋（无眼无扣）': '单开线袋（无眼无扣）',
  '单开衩': '单开衩',
  '单扣袖口': '单扣袖口',
  '单排 1 粒对拉扣': '单排 1 粒对拉扣',
  '单排 1 粒扣': '单排 1 粒扣',
  '单排 2 粒扣': '单排 2 粒扣',
  '单排 3 扣': '单排 3 扣',
  '单排 3 扣 2': '单排 3 扣 2',
  '单排 3 粒扣': '单排 3 粒扣',
  '单排 4 扣': '单排 4 扣',
  '单排 5 扣': '单排 5 扣',
  '单独发': '单独发',
  '单省道': '单省道',
  '单线袋': '单线袋',
  '单线袋（1.2cm）': '单线袋（1.2cm）',
  '单衬衫': '单衬衫',
  '单褶': '单褶',
  '单褶向内': '单褶向内',
  '单褶向内+手工套结': '单褶向内+手工套结',
  '单褶向外': '单褶向外',
  '单褶向外+手工套结': '单褶向外+手工套结',
  '单西裙': '单西裙',
  '单西裙（女装）': '单西裙（女装）',
  '单西裤': '单西裤',
  '单边宝剑头调节袢': '单边宝剑头调节袢',
  '单边小弧形调节袢': '单边小弧形调节袢',
  '单边廓尔格腰': '单边廓尔格腰',
  '卡袋上订商标 + 面料标': '卡袋上订商标 + 面料标',
  '卡袋上订商标+面料标': '卡袋上订商标+面料标',
  '厘米': '厘米',
  '厚羊毛': '厚羊毛',
  '去结算': '去结算',
  '参考值': '参考值',
  '参考图片': '参考图片',
  '参考成衣尺寸': '参考成衣尺寸',
  '参考汇率': '参考汇率',
  '及膝': '及膝',
  '双开叉无防风条': '双开叉无防风条',
  '双开叉防风条': '双开叉防风条',
  '双开线竖口袋': '双开线竖口袋',
  '双开线袋': '双开线袋',
  '双开线袋+圆扣袢+锁眼钉扣': '双开线袋+圆扣袢+锁眼钉扣',
  '双开线袋+锁眼钉扣': '双开线袋+锁眼钉扣',
  '双开线袋（无眼无扣）': '双开线袋（无眼无扣）',
  '双开衩': '双开衩',
  '双排 2 扣 1': '双排 2 扣 1',
  '双排 4 扣 2': '双排 4 扣 2',
  '双排 4 扣 2+尖下摆': '双排 4 扣 2+尖下摆',
  '双排 5 扣 3 斜门襟': '双排 5 扣 3 斜门襟',
  '双排 6 扣 1': '双排 6 扣 1',
  '双排 6 扣 2': '双排 6 扣 2',
  '双排 6 扣 2+尖下摆': '双排 6 扣 2+尖下摆',
  '双排 6 扣 3': '双排 6 扣 3',
  '双排 6 扣 3 斜门襟+尖下摆': '双排 6 扣 3 斜门襟+尖下摆',
  '双排 6 扣 3+尖下摆': '双排 6 扣 3+尖下摆',
  '双排 8 扣 4': '双排 8 扣 4',
  '双排 8 扣 4+尖下摆': '双排 8 扣 4+尖下摆',
  '双省道': '双省道',
  '双线大袋（有袋盖）+ 一字票袋（无袋盖）': '双线大袋（有袋盖）+ 一字票袋（无袋盖）',
  '双线大袋（有袋盖）+ 双线票袋（有袋盖）': '双线大袋（有袋盖）+ 双线票袋（有袋盖）',
  '双线大袋（直角袋盖）+双线票袋（直角袋盖）': '双线大袋（直角袋盖）+双线票袋（直角袋盖）',
  '双线袋': '双线袋',
  '双线袋 + 小圆直袋盖': '双线袋 + 小圆直袋盖',
  '双线袋无袋盖': '双线袋无袋盖',
  '双线袋（无盖）+ 双线票袋（无盖）': '双线袋（无盖）+ 双线票袋（无盖）',
  '双褶': '双褶',
  '双褶向内': '双褶向内',
  '双褶向内+手工套结': '双褶向内+手工套结',
  '双褶向外+手工套结': '双褶向外+手工套结',
  '双褶外': '双褶外',
  '双边廓尔格腰': '双边廓尔格腰',
  '发票': '发票',
  '发票信息': '发票信息',
  '发票号': '发票号',
  '发票管理': '发票管理',
  '发票记录': '发票记录',
  '发货中': '发货中',
  '发货单': '发货单',
  '发货日期': '发货日期',
  '发货管理': '发货管理',
  '发送': '发送',
  '发送失败': '发送失败',
  '发送状态': '发送状态',
  '发送给供应商': '发送给供应商',
  '取消': '取消',
  '取消订单': '取消订单',
  '取消订单失败，请联系客服。': '取消订单失败，请联系客服。',
  '口袋': '口袋',
  '古巴领': '古巴领',
  '可拆卸插片': '可拆卸插片',
  '可用': '可用',
  '可用余额': '可用余额',
  '可用额度': '可用额度',
  '右 3': '右 3',
  '右前 1 个裤袢 1cm': '右前 1 个裤袢 1cm',
  '右前 1 个裤袢 2cm': '右前 1 个裤袢 2cm',
  '右前片下腰口': '右前片下腰口',
  '右前腰部（第 4 个纽扣右侧）': '右前腰部（第 4 个纽扣右侧）',
  '右单开线袋+锁眼钉扣': '右单开线袋+锁眼钉扣',
  '右单开线袋（无眼无扣）': '右单开线袋（无眼无扣）',
  '右双开线袋+桃型袋盖': '右双开线袋+桃型袋盖',
  '右双开线袋+菱形袋盖': '右双开线袋+菱形袋盖',
  '右双开线袋+锁眼钉扣': '右双开线袋+锁眼钉扣',
  '右双开线袋（无眼无扣）': '右双开线袋（无眼无扣）',
  '右开线袋+圆扣袢+锁眼钉扣': '右开线袋+圆扣袢+锁眼钉扣',
  '右手腕': '右手腕',
  '右挂面袋上居中': '右挂面袋上居中',
  '右腰线上双线袋+右袋布内': '右腰线上双线袋+右袋布内',
  '右腰线上双线袋+左袋布内': '右腰线上双线袋+左袋布内',
  '右腰缝上一字袋+右袋布内': '右腰缝上一字袋+右袋布内',
  '右腰缝上一字袋+左袋布内': '右腰缝上一字袋+左袋布内',
  '右腰里刺绣': '右腰里刺绣',
  '右腰里订商标': '右腰里订商标',
  '右腰里订面料标': '右腰里订面料标',
  '右腰顶开缝袋': '右腰顶开缝袋',
  '右表袋+桃型袋盖+锁眼钉扣': '右表袋+桃型袋盖+锁眼钉扣',
  '右表袋+菱形袋盖+锁眼钉扣': '右表袋+菱形袋盖+锁眼钉扣',
  '右袖口': '右袖口',
  '右袖长': '右袖长',
  '右里袋上居中': '右里袋上居中',
  '右驳头眼顺边绣': '右驳头眼顺边绣',
  '合体': '合体',
  '合体要求': '合体要求',
  '合作年限': '合作年限',
  '合作状态': '合作状态',
  '合作等级': '合作等级',
  '合并发票': '合并发票',
  '合格数量': '合格数量',
  '同上衣': '同上衣',
  '同主品类': '同主品类',
  '同上衣里布': '同上衣里布',
  '同大身': '同大身',
  '同西服上衣': '同西服上衣',
  '名称': '名称',
  '后中衩': '后中衩',
  '后中长': '后中长',
  '后台日期': '后台日期',
  '后尖角贴袋': '后尖角贴袋',
  '后开叉型': '后开叉型',
  '后开衩': '后开衩',
  '后片省': '后片省',
  '后片设计': '后片设计',
  '后背内工字褶': '后背内工字褶',
  '后背双褶': '后背双褶',
  '后背双褶+双省': '后背双褶+双省',
  '后背宽': '后背宽',
  '后背明工字褶': '后背明工字褶',
  '后背明工字褶+双省': '后背明工字褶+双省',
  '后背用料': '后背用料',
  '后腰开口': '后腰开口',
  '后腰节': '后腰节',
  '后腰节长': '后腰节长',
  '后表袋+桃型袋盖+暗锁眼钉扣': '后表袋+桃型袋盖+暗锁眼钉扣',
  '后表袋+菱形袋盖+暗锁眼钉扣': '后表袋+菱形袋盖+暗锁眼钉扣',
  '后领底尼上口居中': '后领底尼上口居中',
  '后领底尼下口居中': '后领底尼下口居中',
  '启用': '启用',
  '员工': '员工',
  '员工分红比例': '员工分红比例',
  '员工工资汇总': '员工工资汇总',
  '周一': '周一',
  '周三': '周三',
  '周二': '周二',
  '周五': '周五',
  '周六': '周六',
  '周四': '周四',
  '周日': '周日',
  '咖啡色纯亚麻': '咖啡色纯亚麻',
  '品牌': '品牌',
  '品牌名称': '品牌名称',
  '品类': '品类',
  '品类选择': '品类选择',
  '品类配置': '品类配置',
  '品质': '品质',
  '响应速度': '响应速度',
  '售后': '售后',
  '售后信息': '售后信息',
  '售后单号': '售后单号',
  '售后原因': '售后原因',
  '售后工单': '售后工单',
  '售后沟通': '售后沟通',
  '售后状态': '售后状态',
  '售后申请': '售后申请',
  '售后申请失败，请稍后重试。': '售后申请失败，请稍后重试。',
  '售后申请已提交': '售后申请已提交',
  '售后管理': '售后管理',
  '售后类型': '售后类型',
  '售后记录': '售后记录',
  '售后说明': '售后说明',
  '商标': '商标',
  '商标 + 领标': '商标 + 领标',
  '商标+领标': '商标+领标',
  '商标及码标都订后复势': '商标及码标都订后复势',
  '商标在右': '商标在右',
  '商标在左': '商标在左',
  '商标订下里襟': '商标订下里襟',
  '商标订卡袋上': '商标订卡袋上',
  '商标订后复势': '商标订后复势',
  '商标订后复势+面料标订下里襟': '商标订后复势+面料标订下里襟',
  '四季': '四季',
  '团单提成率': '团单提成率',
  '团队管理提成': '团队管理提成',
  '团队管理提成率': '团队管理提成率',
  '国家/地区': '国家/地区',
  '图文': '图文',
  '放大': '放大',
  '图案': '图案',
  '图片': '图片',
  '图片上传失败，请检查文件格式和大小。': '图片上传失败，请检查文件格式和大小。',
  '图片上传成功': '图片上传成功',
  '图片刺绣': '图片刺绣',
  '圆头 5cm+暗钩': '圆头 5cm+暗钩',
  '圆头 5cm+锁眼钉扣': '圆头 5cm+锁眼钉扣',
  '圆形牛仔袋（又名月牙袋）': '圆形牛仔袋（又名月牙袋）',
  '圆形青果领': '圆形青果领',
  '圆摆': '圆摆',
  '圆肩': '圆肩',
  '圆角 1 眼 2 扣': '圆角 1 眼 2 扣',
  '圆角 2 用': '圆角 2 用',
  '圆角 2 眼 2 扣': '圆角 2 眼 2 扣',
  '圆角立领': '圆角立领',
  '圆角领': '圆角领',
  '圆贴布中褶': '圆贴布中褶',
  '圆贴布大褶': '圆贴布大褶',
  '圆贴布小褶（塔克）': '圆贴布小褶（塔克）',
  '圆贴布无褶': '圆贴布无褶',
  '在右袋布内': '在右袋布内',
  '在左右袋布内': '在左右袋布内',
  '在左袋布内': '在左袋布内',
  '在线': '在线',
  '地址': '地址',
  '城市': '城市',
  '基准价': '基准价',
  '基本信息': '基本信息',
  '基本工资': '基本工资',
  '基础价格': '基础价格',
  '基础价格表': '基础价格表',
  '基础围度已完成': '基础围度已完成',
  '基础金额': '基础金额',
  '增加': '增加',
  '处理': '处理',
  '处理中': '处理中',
  '处理方式': '处理方式',
  '处罚规则': '处罚规则',
  '备注': '备注',
  '备注已对门店可见': '备注已对门店可见',
  '备注已隐藏': '备注已隐藏',
  '点击隐藏此备注': '点击隐藏此备注',
  '点击显示此备注': '点击显示此备注',
  '备注与特殊说明': '备注与特殊说明',
  '备注信息': '备注信息',
  '备注（可选）': '备注（可选）',
  '备货': '备货',
  '备货中': '备货中',
  '复制': '复制',
  '复制旧订单': '复制旧订单',
  '复制订单': '复制订单',
  '复制订单失败': '复制订单失败',
  '复制链接': '复制链接',
  '复用全部信息': '复用全部信息',
  '复用旧订单': '复用旧订单',
  '复用旧订单尺寸': '复用旧订单尺寸',
  '夏季': '夏季',
  '外翻 3.5cm': '外翻 3.5cm',
  '外翻 3cm': '外翻 3cm',
  '外翻 5.5cm': '外翻 5.5cm',
  '外翻 5cm': '外翻 5cm',
  '外翻 6cm': '外翻 6cm',
  '外裤长': '外裤长',
  '外贡针线': '外贡针线',
  '外过肩撞色': '外过肩撞色',
  '外领面居中': '外领面居中',
  '多个标签用逗号分隔': '多个标签用逗号分隔',
  '大 U 型': '大 U 型',
  '大八字领': '大八字领',
  '大圆型下摆': '大圆型下摆',
  '大挂面': '大挂面',
  '大挂面无里（包边）': '大挂面无里（包边）',
  '大挂面无里（贡针）': '大挂面无里（贡针）',
  '大挂面（适合无里布工艺）': '大挂面（适合无里布工艺）',
  '大腿围': '大腿围',
  '大衣': '大衣',
  '大衣尺寸': '大衣尺寸',
  '大衣设计': '大衣设计',
  '大衣设计尺寸': '大衣设计尺寸',
  '大衣部位': '大衣部位',
  '天': '天',
  '天然混纺系列': '天然混纺系列',
  '奖励通知': '奖励通知',
  '套装内所有品类使用相同面料，如需不同面料请分开下单': '套装内所有品类使用相同面料，如需不同面料请分开下单',
  '奢华档': '奢华档',
  '奢华档（高）': '奢华档（高）',
  '女': '女',
  '如：150': '如：150',
  '如：2026-04 量体': '如：2026-04 量体',
  '如：3': '如：3',
  '如：DHL / FedEx': '如：DHL / FedEx',
  '如：DHL、顺丰': '如：DHL、顺丰',
  '如：HS-2024-001': '如：HS-2024-001',
  '如：Holland & Sherry': '如：Holland & Sherry',
  '如：修身、宽松': '如：修身、宽松',
  '如：对羊毛过敏': '如：对羊毛过敏',
  '如：细条纹、人字纹': '如：细条纹、人字纹',
  '姓名': '姓名',
  '婚礼系列': '婚礼系列',
  '子账号': '子账号',
  '字体': '字体',
  '字体颜色': '字体颜色',
  '字体颜色（线色号）': '字体颜色（线色号）',
  '存储地点': '存储地点',
  '完成录入待提交': '完成录入待提交',
  '定制下单': '定制下单',
  '定制单提成率': '定制单提成率',
  '定制设计': '定制设计',
  '宝剑头 5cm+暗钩': '宝剑头 5cm+暗钩',
  '宝剑头 5cm+锁眼钉扣': '宝剑头 5cm+锁眼钉扣',
  '宝剑头挂面': '宝剑头挂面',
  '实发工资': '实发工资',
  '实发提成': '实发提成',
  '审批人': '审批人',
  '审批备注': '审批备注',
  '审批状态': '审批状态',
  '审核中': '审核中',
  '审核通过': '审核通过',
  '审核通过，已确认付款': '审核通过，已确认付款',
  '审核驳回': '审核驳回',
  '客供图片': '客供图片',
  '客供里布': '客供里布',
  '客供': '客供',
  '待采': '待采',
  '客供面料（待采）': '客供面料（待采）',
  '客供里布（待采）': '客供里布（待采）',
  '客供纽扣（待采）': '客供纽扣（待采）',
  '客供面料（邮寄）': '客供面料（邮寄）',
  '客供里布（邮寄）': '客供里布（邮寄）',
  '客供纽扣（邮寄）': '客供纽扣（邮寄）',
  '系统': '系统',
  '客供面料': '客供面料',
  '当前继承上衣客供面料': '当前继承上衣客供面料',
  '其它面料': '其它面料',
  '其它里布': '其它里布',
  '其它纽扣': '其它纽扣',
  '客供面料（CMT来料加工）：由客户自行提供面料，发票中面料费用为零，仅计工艺加工费。请填写每块面料的物流信息。': '客供面料（CMT来料加工）：由客户自行提供面料，发票中面料费用为零，仅计工艺加工费。请填写每块面料的物流信息。',
  '客户': '客户',
  '客户/门店': '客户/门店',
  '客户信息': '客户信息',
  '客户信息 & 款式设计': '客户信息 & 款式设计',
  '客户信息&款式设计': '客户信息&款式设计',
  '客户创建失败': '客户创建失败',
  '客户创建成功': '客户创建成功',
  '客户取消': '客户取消',
  '客户名称': '客户名称',
  '客户基本信息': '客户基本信息',
  '客户姓名': '客户姓名',
  '客户报价单': '客户报价单',
  '客户标签': '客户标签',
  '客户状态': '客户状态',
  '客户编号': '客户编号',
  '客户详情': '客户详情',
  '宴会系列': '宴会系列',
  '宽松': '宽松',
  '寄件日期': '寄件日期',
  '寄出日期': '寄出日期',
  '密码': '密码',
  '密码修改失败': '密码修改失败',
  '密码修改成功': '密码修改成功',
  '密钥': '密钥',
  '对账单': '对账单',
  '对账截止日': '对账截止日',
  '对账起始日': '对账起始日',
  '导入': '导入',
  '导出': '导出',
  '导出列表': '导出列表',
  '导出功能开发中': '导出功能开发中',
  '导出发票': '导出发票',
  '小 U 型': '小 U 型',
  '小圆头 5cm+暗钩': '小圆头 5cm+暗钩',
  '小圆头 5cm+锁眼钉扣': '小圆头 5cm+锁眼钉扣',
  '小圆青果领': '小圆青果领',
  '小腿围': '小腿围',
  '小腿高度': '小腿高度',
  '小计': '小计',
  '尖角下摆': '尖角下摆',
  '尖青果领（JD 尖青果领）': '尖青果领（JD 尖青果领）',
  '尺寸录入': '尺寸录入',
  '尺寸汇总': '尺寸汇总',
  '屈身体': '屈身体',
  '工作台': '工作台',
  '工厂供应商': '工厂供应商',
  '工厂原始编号': '工厂原始编号',
  '工厂已确认': '工厂已确认',
  '工厂待审核': '工厂待审核',
  '工厂成本': '工厂成本',
  '工厂成本配置': '工厂成本配置',
  '工字褶': '工字褶',
  '工艺': '工艺',
  '加工费': '加工费',
  '工艺类型': '工艺类型',
  '工艺配置': '工艺配置',
  '左 1 右 2': '左 1 右 2',
  '左 1 右 3': '左 1 右 3',
  '左 2 右 1': '左 2 右 1',
  '左 2 右 2': '左 2 右 2',
  '左 3': '左 3',
  '左 3 右 1': '左 3 右 1',
  '左切角胸袋': '左切角胸袋',
  '左切角胸袋+切角袋盖+锁眼钉扣': '左切角胸袋+切角袋盖+锁眼钉扣',
  '左前片下腰口': '左前片下腰口',
  '左前腰部（第 4 个纽扣左侧）': '左前腰部（第 4 个纽扣左侧）',
  '左单开线袋+锁眼钉扣': '左单开线袋+锁眼钉扣',
  '左单开线袋（无眼无扣）': '左单开线袋（无眼无扣）',
  '左双开线袋+圆扣袢+锁眼钉扣': '左双开线袋+圆扣袢+锁眼钉扣',
  '左双开线袋+桃型袋盖': '左双开线袋+桃型袋盖',
  '左双开线袋+菱形袋盖': '左双开线袋+菱形袋盖',
  '左双开线袋+锁眼钉扣': '左双开线袋+锁眼钉扣',
  '左双开线袋（无眼无扣）': '左双开线袋（无眼无扣）',
  '左右切角胸袋': '左右切角胸袋',
  '左右切角胸袋+切角袋盖+锁眼钉扣': '左右切角胸袋+切角袋盖+锁眼钉扣',
  '左右圆胸袋': '左右圆胸袋',
  '左右圆角胸袋+圆角袋盖+锁眼钉扣': '左右圆角胸袋+圆角袋盖+锁眼钉扣',
  '左右宝剑头调节袢': '左右宝剑头调节袢',
  '左右小弧形调节袢': '左右小弧形调节袢',
  '左右尖角胸袋': '左右尖角胸袋',
  '左右工字褶贴袋': '左右工字褶贴袋',
  '左右工字褶贴袋（无袋盖）': '左右工字褶贴袋（无袋盖）',
  '左右工字褶贴袋（桃型袋盖+钉扣）': '左右工字褶贴袋（桃型袋盖+钉扣）',
  '左右工字褶贴袋（直袋盖）': '左右工字褶贴袋（直袋盖）',
  '左右方角胸袋': '左右方角胸袋',
  '左右方角胸袋+切角袋盖+锁眼钉扣': '左右方角胸袋+切角袋盖+锁眼钉扣',
  '左右方角胸袋+尖角袋盖+锁眼钉扣': '左右方角胸袋+尖角袋盖+锁眼钉扣',
  '左右方角胸袋+方角袋盖+锁眼钉扣': '左右方角胸袋+方角袋盖+锁眼钉扣',
  '左右暗风琴褶贴袋': '左右暗风琴褶贴袋',
  '左右暗风琴褶贴袋（无袋盖）': '左右暗风琴褶贴袋（无袋盖）',
  '左右暗风琴褶贴袋（桃型袋盖+钉扣）': '左右暗风琴褶贴袋（桃型袋盖+钉扣）',
  '左右暗风琴褶贴袋（直袋盖）': '左右暗风琴褶贴袋（直袋盖）',
  '左右驳头眼': '左右驳头眼',
  '左商标+右面料标': '左商标+右面料标',
  '左商标+右面料标+领标': '左商标+右面料标+领标',
  '左商标右面料标': '左商标右面料标',
  '左圆胸袋': '左圆胸袋',
  '左圆角胸袋+圆角袋盖+锁眼钉扣': '左圆角胸袋+圆角袋盖+锁眼钉扣',
  '左尖角胸袋': '左尖角胸袋',
  '左工字褶贴袋': '左工字褶贴袋',
  '左工字褶贴袋（无袋盖）': '左工字褶贴袋（无袋盖）',
  '左工字褶贴袋（桃型袋盖+钉扣）': '左工字褶贴袋（桃型袋盖+钉扣）',
  '左工字褶贴袋（直袋盖）': '左工字褶贴袋（直袋盖）',
  '左手腕': '左手腕',
  '左挂面袋上居中': '左挂面袋上居中',
  '左方角胸袋': '左方角胸袋',
  '左方角胸袋+切角袋盖+锁眼钉扣': '左方角胸袋+切角袋盖+锁眼钉扣',
  '左方角胸袋+尖角袋盖+锁眼钉扣': '左方角胸袋+尖角袋盖+锁眼钉扣',
  '左方角胸袋+方角袋盖+锁眼钉扣': '左方角胸袋+方角袋盖+锁眼钉扣',
  '左暗风琴褶贴袋': '左暗风琴褶贴袋',
  '左暗风琴褶贴袋（无袋盖）': '左暗风琴褶贴袋（无袋盖）',
  '左暗风琴褶贴袋（桃型袋盖+钉扣）': '左暗风琴褶贴袋（桃型袋盖+钉扣）',
  '左暗风琴褶贴袋（直袋盖）': '左暗风琴褶贴袋（直袋盖）',
  '左标准明贴袋（无袋盖）': '左标准明贴袋（无袋盖）',
  '左标准明贴袋（桃形袋盖+钉扣）': '左标准明贴袋（桃形袋盖+钉扣）',
  '左标准明贴袋（桃形袋盖）': '左标准明贴袋（桃形袋盖）',
  '左标准明贴袋（直袋盖）': '左标准明贴袋（直袋盖）',
  '左胸前': '左胸前',
  '左胸弧形贴袋': '左胸弧形贴袋',
  '左胸弧形贴袋（无袋盖）': '左胸弧形贴袋（无袋盖）',
  '左腰里刺绣': '左腰里刺绣',
  '左腰里订商标': '左腰里订商标',
  '左腰里订面料标': '左腰里订面料标',
  '左袖口': '左袖口',
  '左袖比右袖长 0.5cm，应对客户轻微高低肩。': '左袖比右袖长 0.5cm，应对客户轻微高低肩。',
  '左袖长': '左袖长',
  '左里袋上居中': '左里袋上居中',
  '左面料标+右商标': '左面料标+右商标',
  '左面料标右商标': '左面料标右商标',
  '左领尖绣字（顺边缘）': '左领尖绣字（顺边缘）',
  '左驳头眼顺边绣': '左驳头眼顺边绣',
  '已付款': '已付款',
  '已付金额': '已付金额',
  '已发货': '已发货',
  '已发货数量': '已发货数量',
  '已发货订单': '已发货订单',
  '已发送': '已发送',
  '已取消': '已取消',
  '已复制订单': '已复制订单',
  '已复用尺寸': '已复用尺寸',
  '已完成': '已完成',
  '已审核': '已审核',
  '已寄出': '已寄出',
  '已开票': '已开票',
  '已提交': '已提交',
  '已提交订单': '已提交订单',
  '已收货': '已收货',
  '已暂存为草稿': '已暂存为草稿',
  '已查看': '已查看',
  '已用额度': '已用额度',
  '已申请': '已申请',
  '已确认': '已确认',
  '已确认付款': '已确认付款',
  '已签收': '已签收',
  '已质检': '已质检',
  '已送达': '已送达',
  '已选': '已选',
  '已选择': '已选择',
  '已选择现款设计': '已选择现款设计',
  '已选：': '已选：',
  '已采购': '已采购',
  '已锁定（与': '已锁定（与',
  '已驳回': '已驳回',
  '带盖口袋': '带盖口袋',
  '常规': '常规',
  '常规加厚肩（垫肩 1.2cm + 有棉条）': '常规加厚肩（垫肩 1.2cm + 有棉条）',
  '常规款': '常规款',
  '常规纽扣': '常规纽扣',
  '常规肩（垫肩 0.8cm + 有棉条）': '常规肩（垫肩 0.8cm + 有棉条）',
  '常规薄肩（垫肩 0.5cm + 有棉条）': '常规薄肩（垫肩 0.5cm + 有棉条）',
  '常规超薄肩（垫肩 0.1cm + 有棉条）': '常规超薄肩（垫肩 0.1cm + 有棉条）',
  '常规里袋 + 一字笔袋': '常规里袋 + 一字笔袋',
  '常规里袋 + 一字笔袋 + 卡袋': '常规里袋 + 一字笔袋 + 卡袋',
  '常规里袋 + 水滴笔袋': '常规里袋 + 水滴笔袋',
  '常规里袋 + 水滴笔袋 + 卡袋': '常规里袋 + 水滴笔袋 + 卡袋',
  '平台服务费': '平台服务费',
  '平肩': '平肩',
  '平脚': '平脚',
  '平腰头+暗钩': '平腰头+暗钩',
  '平腰头+锁眼钉扣': '平腰头+锁眼钉扣',
  '平袋盖（直角）': '平袋盖（直角）',
  '平角青果领': '平角青果领',
  '平驳头': '平驳头',
  '平驳领': '平驳领',
  '年度税后利润': '年度税后利润',
  '库存': '库存',
  '库存不足，请选择其他物料或联系客服。': '库存不足，请选择其他物料或联系客服。',
  '库存流水': '库存流水',
  '库存物料': '库存物料',
  '库存管理': '库存管理',
  '库存调整': '库存调整',
  '应付总金额': '应付总金额',
  '应发工资': '应发工资',
  '度假系列': '度假系列',
  '开始日期': '开始日期',
  '开始生产前需支付50%定金。': '开始生产前需支付50%定金。',
  '开票日期': '开票日期',
  '异常冻结': '异常冻结',
  '异常订单': '异常订单',
  '弧形工字褶贴袋': '弧形工字褶贴袋',
  '弧形工字褶贴袋（桃型袋盖）': '弧形工字褶贴袋（桃型袋盖）',
  '弧形工字褶贴袋（直袋盖）': '弧形工字褶贴袋（直袋盖）',
  '弧形戗驳领': '弧形戗驳领',
  '弧形暗风琴褶贴袋': '弧形暗风琴褶贴袋',
  '弧形暗风琴褶贴袋（桃型袋盖）': '弧形暗风琴褶贴袋（桃型袋盖）',
  '弧形暗风琴褶贴袋（直袋盖）': '弧形暗风琴褶贴袋（直袋盖）',
  '弧形胸袋': '弧形胸袋',
  '弧形贴袋': '弧形贴袋',
  '弧形贴袋+ 右袋中袋': '弧形贴袋+ 右袋中袋',
  '弧形贴袋（时尚贴袋）': '弧形贴袋（时尚贴袋）',
  '弯挂面': '弯挂面',
  '当前在线门店': '当前在线门店',
  '当前密码': '当前密码',
  '当前库存': '当前库存',
  '当前折扣率为': '当前折扣率为',
  '当前状态': '当前状态',
  '待付款': '待付款',
  '待付金额': '待付金额',
  '待初审': '待初审',
  '待发货': '待发货',
  '待复审': '待复审',
  '待完成': '待完成',
  '待审核': '待审核',
  '待审核订单': '待审核订单',
  '待审核订单总数': '待审核订单总数',
  '待审核金额(USD)': '待审核金额(USD)',
  '待开票': '待开票',
  '待推送': '待推送',
  '待提交订单': '待提交订单',
  '待确认': '待确认',
  '待确认付款': '待确认付款',
  '待终审': '待终审',
  '待财务审核': '待财务审核',
  '待质检': '待质检',
  '待选': '待选',
  '待采购': '待采购',
  '待采购面料': '待采购面料',
  '心型': '心型',
  '忘记密码': '忘记密码',
  '快捷下单': '快捷下单',
  '快递运单号': '快递运单号',
  '快速搜索': '快速搜索',
  '性别': '性别',
  '总SKU': '总SKU',
  '总肩宽': '总肩宽',
  '总采购额': '总采购额',
  '您有未保存的更改，是否继续编辑？': '您有未保存的更改，是否继续编辑？',
  '意式圆形 1 扣': '意式圆形 1 扣',
  '意式圆形 2 扣': '意式圆形 2 扣',
  '意式直型 1 扣': '意式直型 1 扣',
  '意式直型 2 扣': '意式直型 2 扣',
  '意式长双宝剑头+锁眼钉扣': '意式长双宝剑头+锁眼钉扣',
  '意式长圆头+锁眼钉扣': '意式长圆头+锁眼钉扣',
  '意式长方头+锁眼钉扣': '意式长方头+锁眼钉扣',
  '成分': '成分',
  '成本明细': '成本明细',
  '成衣商城': '成衣商城',
  '成衣商城功能开发中，敬请期待': '成衣商城功能开发中，敬请期待',
  '成衣尺寸': '成衣尺寸',
  '审核成衣尺寸': '审核成衣尺寸',
  '成衣尺寸（AI建议）': '成衣尺寸（AI建议）',
  '我的客户': '我的客户',
  '我的物料': '我的物料',
  '我的订单': '我的订单',
  '我的设计专员': '我的设计专员',
  '我的账单': '我的账单',
  '我的账号': '我的账号',
  '戗驳头': '戗驳头',
  '所属门店': '所属门店',
  '所有价格以美元（USD）计算，自报价日起30天内有效。': '所有价格以美元（USD）计算，自报价日起30天内有效。',
  '所有服装均为量身定制，不接受退换。': '所有服装均为量身定制，不接受退换。',
  '所有订单': '所有订单',
  '所有订单管理': '所有订单管理',
  '所有金额以美元(USD)计价。实际价格可能根据面料等级、批量折扣等规则进行调整，最终以后台审核后的价格为准。': '所有金额以美元(USD)计价。实际价格可能根据面料等级、批量折扣等规则进行调整，最终以后台审核后的价格为准。',
  '所选品类': '所选品类',
  '所选物料在当前工厂不可用。': '所选物料在当前工厂不可用。',
  '手动发送公告': '手动发送公告',
  '手工同步状态': '手工同步状态',
  '手工圆头锁眼': '手工圆头锁眼',
  '手工米兰眼不开刀': '手工米兰眼不开刀',
  '手工米兰眼开刀': '手工米兰眼开刀',
  '手工调价': '手工调价',
  '扣减': '扣减',
  '扣款合计': '扣款合计',
  '批量价格表': '批量价格表',
  '批量发送邮件': '批量发送邮件',
  '批量打印面单': '批量打印面单',
  '批量折扣': '批量折扣',
  '批量操作': '批量操作',
  '技术审核时间': '技术审核时间',
  '技术已审核': '技术已审核',
  '投产工厂': '投产工厂',
  '投诉与反馈': '投诉与反馈',
  '投诉与反馈邮箱': '投诉与反馈邮箱',
  '货币单位：USD': '货币单位：USD',
  '折扣': '折扣',
  '折，低于系统设置的最低折扣系数，需要提交折扣审批申请。': '折，低于系统设置的最低折扣系数，需要提交折扣审批申请。',
  '报价工具': '报价工具',
  '报价总额（USD）': '报价总额（USD）',
  '报价日期': '报价日期',
  '报废': '报废',
  '拖拽排序': '拖拽排序',
  '挂面款式': '挂面款式',
  '按件': '按件',
  '按功能分类': '按功能分类',
  '按图设计': '按图设计',
  '按图设计款': '按图设计款',
  '按场合分类': '按场合分类',
  '按字母': '按字母',
  '按季节分类': '按季节分类',
  '按订单': '按订单',
  '挺缝线压线 0.2cm': '挺缝线压线 0.2cm',
  '挺胸体': '挺胸体',
  '接口地址': '接口地址',
  '接收角色': '接收角色',
  '推送失败': '推送失败',
  '推送工厂': '推送工厂',
  '描述': '描述',
  '提交': '提交',
  '提交失败': '提交失败',
  '提交失败，请检查网络或后端服务': '提交失败，请检查网络或后端服务',
  '提交审批失败': '提交审批失败',
  '提交审核': '提交审核',
  '提交审核成功': '提交审核成功',
  '提交折扣审批': '提交折扣审批',
  '提交申请': '提交申请',
  '提交订单': '提交订单',
  '提成合计': '提成合计',
  '提成明细': '提成明细',
  '提成规则配置': '提成规则配置',
  '提成金额': '提成金额',
  '清除': '清除',
  '搜索': '搜索',
  '搜索位置...': '搜索位置...',
  '搜索历史订单': '搜索历史订单',
  '搜索姓名/电话/邮箱/地址': '搜索姓名/电话/邮箱/地址',
  '搜索字体...': '搜索字体...',
  '搜索工艺类型、订单号、客户名、面料编码...': '搜索工艺类型、订单号、客户名、面料编码...',
  '搜索物料': '搜索物料',
  '搜索编号 / 颜色': '搜索编号 / 颜色',
  '搜索编号/名称...': '搜索编号/名称...',
  '搜索编号/颜色': '搜索编号/颜色',
  '搜索订单号/客户/门店': '搜索订单号/客户/门店',
  '搜索订单号/客户/面料': '搜索订单号/客户/面料',
  '搜索选择客户': '搜索选择客户',
  '搜索颜色...': '搜索颜色...',
  '搜索高度...': '搜索高度...',
  '摆围': '摆围',
  '撞色设计': '撞色设计',
  '撞色面料': '撞色面料',
  '操作': '操作',
  '操作人': '操作人',
  '操作内容': '操作内容',
  '操作失败': '操作失败',
  '操作成功': '操作成功',
  '操作日志': '操作日志',
  '操作时间': '操作时间',
  '支付方式': '支付方式',
  '收支明细': '收支明细',
  '收货单': '收货单',
  '收货地址': '收货地址',
  '收货地点': '收货地点',
  '收货管理': '收货管理',
  '收费系列': '收费系列',
  '放松量': '放松量',
  '数据录入校验 (Checklist)': '数据录入校验 (Checklist)',
  '数据看板': '数据看板',
  '数量': '数量',
  '整个袖口撞色': '整个袖口撞色',
  '整个领子和袖口撞色': '整个领子和袖口撞色',
  '整个领子撞色': '整个领子撞色',
  '文字': '文字',
  '料卡': '料卡',
  '斜双开线口袋': '斜双开线口袋',
  '斜插袋': '斜插袋',
  '斜袋': '斜袋',
  '斜袋：单线袋': '斜袋：单线袋',
  '斜袋：双线大袋（有袋盖）+一字票袋（无袋盖）': '斜袋：双线大袋（有袋盖）+一字票袋（无袋盖）',
  '斜袋：双线大袋（有袋盖）+双线票袋（无袋盖）': '斜袋：双线大袋（有袋盖）+双线票袋（无袋盖）',
  '斜袋：双线大袋（有袋盖）+双线票袋（有袋盖）': '斜袋：双线大袋（有袋盖）+双线票袋（有袋盖）',
  '斜袋：双线大袋（直角袋盖）+双线票袋（直角袋盖）': '斜袋：双线大袋（直角袋盖）+双线票袋（直角袋盖）',
  '斜袋：双线袋+小圆直袋盖': '斜袋：双线袋+小圆直袋盖',
  '斜袋：双线袋无袋盖': '斜袋：双线袋无袋盖',
  '斜袋：双线袋（无盖）+双线票袋（无盖）': '斜袋：双线袋（无盖）+双线票袋（无盖）',
  '斜袋：平袋盖（直角）': '斜袋：平袋盖（直角）',
  '斜角青果领': '斜角青果领',
  '斜里襟+内小圆头裤袢': '斜里襟+内小圆头裤袢',
  '斜里襟+内小宝剑头裤袢': '斜里襟+内小宝剑头裤袢',
  '斜里襟+内小方头裤袢': '斜里襟+内小方头裤袢',
  '断货': '断货',
  '新品上架': '新品上架',
  '新增付款记录': '新增付款记录',
  '新增客户': '新增客户',
  '新增尺寸': '新增尺寸',
  '新增尺寸记录': '新增尺寸记录',
  '新增返修单': '新增返修单',
  '新增量体档案': '新增量体档案',
  '新备注': '新备注',
  '新密码': '新密码',
  '新建订单': '新建订单',
  '新款发布': '新款发布',
  '新面料上线': '新面料上线',
  '新面料系列现已上架，欢迎选购': '新面料系列现已上架，欢迎选购',
  '方式': '方式',
  '无': '无',
  '添加图片': '添加图片',
  '无体型和款式图': '无体型和款式图',
  '无体型特征记录': '无体型特征记录',
  '无刺绣': '无刺绣',
  '无叉': '无叉',
  '无口袋': '无口袋',
  '无开口': '无开口',
  '无开衩': '无开衩',
  '无弧度戗驳领（JD 直戗驳领）': '无弧度戗驳领（JD 直戗驳领）',
  '无折扣': '无折扣',
  '无挺缝线': '无挺缝线',
  '无插片': '无插片',
  '无数据': '无数据',
  '无标': '无标',
  '无省': '无省',
  '无结构无胸衬': '无结构无胸衬',
  '无背带扣': '无背带扣',
  '无胸袋': '无胸袋',
  '无胸袋+下单开线袋': '无胸袋+下单开线袋',
  '无胸袋+下双开线袋': '无胸袋+下双开线袋',
  '无胸袋+下贴袋': '无胸袋+下贴袋',
  '无腰带': '无腰带',
  '无腰设计': '无腰设计',
  '无色丁': '无色丁',
  '无表袋': '无表袋',
  '无衬': '无衬',
  '无袋': '无袋',
  '无袋盖': '无袋盖',
  '无袖叉': '无袖叉',
  '无裤袢': '无裤袢',
  '无褶': '无褶',
  '无褶双省': '无褶双省',
  '无褶无褶': '无褶无褶',
  '无贡针': '无贡针',
  '无里布': '无里布',
  '无锁眼无纽扣': '无锁眼无纽扣',
  '无驳头眼': '无驳头眼',
  '日': '日',
  '日常通知': '日常通知',
  '日志管理': '日志管理',
  '日期': '日期',
  '时尚档': '时尚档',
  '时尚档（高）': '时尚档（高）',
  '时间': '时间',
  '明细': '明细',
  '明门襟 3.5cm': '明门襟 3.5cm',
  '明门襟 3cm': '明门襟 3cm',
  '春秋': '春秋',
  '是': '是',
  '否': '否',
  '提示': '提示',
  '当前订单保存为草稿时才可以生成 AI预览图，是否保存？': '当前订单保存为草稿时才可以生成 AI预览图，是否保存？',
  '是否余料': '是否余料',
  '是否加急': '是否加急',
  '显示 / 隐藏': '显示 / 隐藏',
  '显示高级信息': '显示高级信息',
  '普通': '普通',
  '普通工字褶贴袋': '普通工字褶贴袋',
  '普通工字褶贴袋（桃型袋盖）': '普通工字褶贴袋（桃型袋盖）',
  '普通工字褶贴袋（直袋盖）': '普通工字褶贴袋（直袋盖）',
  '普通暗风琴褶贴袋': '普通暗风琴褶贴袋',
  '普通暗风琴褶贴袋（桃型袋盖）': '普通暗风琴褶贴袋（桃型袋盖）',
  '普通暗风琴褶贴袋（直袋盖）': '普通暗风琴褶贴袋（直袋盖）',
  '普通贴袋': '普通贴袋',
  '普通贴袋+右袋中袋': '普通贴袋+右袋中袋',
  '暂不取消': '暂不取消',
  '暂存': '暂存',
  '暂存功能开发中': '暂存功能开发中',
  '暂存单': '暂存单',
  '暂存单数量': '暂存单数量',
  '暂存失败': '暂存失败',
  '暂存订单': '暂存订单',
  '草稿已保存': '草稿已保存',
  '请完善客户信息': '请完善客户信息',
  '客户档案保存失败，请重试': '客户档案保存失败，请重试',
  '您的账号尚未通过门店审核，暂时无法下单': '您的账号尚未通过门店审核，暂时无法下单',
  '门店已被禁用，请联系管理员': '门店已被禁用，请联系管理员',
  '权限不足，无法操作': '权限不足，无法操作',
  '您的账号尚未分配门店，请联系设计师': '您的账号尚未分配门店，请联系设计师',
  '账号未关联有效门店，暂时无法创建或保存订单': '账号未关联有效门店，暂时无法创建或保存订单',
  '暂无付款记录': '暂无付款记录',
  '暂无刺绣配置': '暂无刺绣配置',
  '暂无发票': '暂无发票',
  '暂无售后记录': '暂无售后记录',
  '暂无商品': '暂无商品',
  '暂无图片': '暂无图片',
  '暂无备注': '暂无备注',
  '暂无客户数据': '暂无客户数据',
  '暂无客户，点击 “新增客户” 创建。': '暂无客户，点击 “新增客户” 创建。',
  '暂无寄出记录': '暂无寄出记录',
  '暂无待审核订单': '暂无待审核订单',
  '暂无数据': '暂无数据',
  '暂无款式配置': '暂无款式配置',
  '暂无款式配置，请在Step1中选择': '暂无款式配置，请在Step1中选择',
  '暂无流水记录': '暂无流水记录',
  '暂无消息': '暂无消息',
  '暂无系统面料数据': '暂无系统面料数据',
  '暂无订单': '暂无订单',
  '暂无订单数据': '暂无订单数据',
  '暂无订单，点击 “创建新订单” 开始。': '暂无订单，点击 “创建新订单” 开始。',
  '暂无记录': '暂无记录',
  '暂无设计选项': '暂无设计选项',
  '暂无设计项': '暂无设计项',
  '暂无购买记录': '暂无购买记录',
  '暂无采购记录': '暂无采购记录',
  '暂无量体档案': '暂无量体档案',
  '暗门襟 3.5cm': '暗门襟 3.5cm',
  '暗门襟 3cm': '暗门襟 3cm',
  '更多': '更多',
  '更多设计': '更多设计',
  '最新面料': '最新面料',
  '最新面料/新款发布': '最新面料/新款发布',
  '最近下单': '最近下单',
  '最近下单日期': '最近下单日期',
  '最近订单': '最近订单',
  '月': '月',
  '月份': '月份',
  '月处理订单量': '月处理订单量',
  '月牙袋+右双线零钱袋': '月牙袋+右双线零钱袋',
  '月牙袋+右零钱贴袋': '月牙袋+右零钱贴袋',
  '月负责订单金额': '月负责订单金额',
  '月销售额': '月销售额',
  '有效期至': '有效期至',
  '有背带扣': '有背带扣',
  '有货': '有货',
  '服务与反馈中心': '服务与反馈中心',
  '服务暂时不可用，请稍后重试。': '服务暂时不可用，请稍后重试。',
  '服务项目': '服务项目',
  '服装小计': '服装小计',
  '未付款': '未付款',
  '未付余额': '未付余额',
  '凭证图片': '凭证图片',
  '确认时间': '确认时间',
  '已作废': '已作废',
  '下载 PDF': '下载 PDF',
  '承运商': '承运商',
  '发货图片': '发货图片',
  '未付款提醒': '未付款提醒',
  '未发送': '未发送',
  '未找到结果，请尝试其他关键词。': '未找到结果，请尝试其他关键词。',
  '未来之星': '未来之星',
  '未知': '未知',
  '未知错误': '未知错误',
  '未选择': '未选择',
  '未选择面料': '未选择面料',
  '本人团单销售额': '本人团单销售额',
  '本人定制单销售额': '本人定制单销售额',
  '本人权重点数': '本人权重点数',
  '本布光样': '本布光样',
  '本布光样手工': '本布光样手工',
  '本布手工毛样': '本布手工毛样',
  '本布毛样': '本布毛样',
  '本月新单': '本月新单',
  '本期余额': '本期余额',
  '本期支出': '本期支出',
  '本期收入': '本期收入',
  '机器假眼不开刀': '机器假眼不开刀',
  '机器假眼开刀': '机器假眼开刀',
  '机器圆头锁眼不开刀': '机器圆头锁眼不开刀',
  '机器圆头锁眼开刀': '机器圆头锁眼开刀',
  '权限': '权限',
  '权限分配': '权限分配',
  '条款与条件': '条款与条件',
  '来图设计': '来图设计',
  '来料加工': '来料加工',
  '来料加工价格': '来料加工价格',
  '来料加工价格表': '来料加工价格表',
  '查看': '查看',
  '查看全部': '查看全部',
  '查看发票': '查看发票',
  '查看合并发票': '查看合并发票',
  '查看售后沟通': '查看售后沟通',
  '查看背面': '查看背面',
  '查看订单': '查看订单',
  '查看订单详情': '查看订单详情',
  '查看详情': '查看详情',
  '查看账单': '查看账单',
  '标准': '标准',
  '标准价格表': '标准价格表',
  '标准体': '标准体',
  '标准八字领': '标准八字领',
  '标准圆角': '标准圆角',
  '标准工艺': '标准工艺',
  '标准腰带': '标准腰带',
  '标准贡针': '标准贡针',
  '标准领': '标准领',
  '标准（14 天）': '标准（14 天）',
  '标签': '标签',
  '标签搜索': '标签搜索',
  '标记异常': '标记异常',
  '标题': '标题',
  '样本册': '样本册',
  '档位面料价（USD/m）': '档位面料价（USD/m）',
  '档案名称': '档案名称',
  '检测到新版本，请点击下方按钮刷新页面获取最新资源。': '检测到新版本，请点击下方按钮刷新页面获取最新资源。',
  '检索标签': '检索标签',
  '棕色': '棕色',
  '棕色法兰绒': '棕色法兰绒',
  '欢迎回来': '欢迎回来',
  '欢迎回来，查看您的订单和账户状态': '欢迎回来，查看您的订单和账户状态',
  '款号': '款号',
  '款式信息': '款式信息',
  '款式名称': '款式名称',
  '款式明细': '款式明细',
  '款式设计': '款式设计',
  '款式配置汇总': '款式配置汇总',
  '款式长度': '款式长度',
  '款式预览': '款式预览',
  '款式风格': '款式风格',
  '款式风格搭配': '款式风格搭配',
  '正常': '正常',
  '正常 14天': '正常 14天',
  '正常14天': '正常14天',
  '正常腰头': '正常腰头',
  '正式': '正式',
  '正面': '正面',
  '正面图': '正面图',
  '此字段为必填项。': '此字段为必填项。',
  '每件': '每件',
  '每单': '每单',
  '每字': '每字',
  '毛利': '毛利',
  '毛利率': '毛利率',
  '毛边 10cm': '毛边 10cm',
  '毛边 7cm': '毛边 7cm',
  '汇款': '汇款',
  '汗贴造型': '汗贴造型',
  '沟通': '沟通',
  '沟通态度': '沟通态度',
  '法式切角': '法式切角',
  '法式圆角': '法式圆角',
  '法式斜里襟': '法式斜里襟',
  '法式直角': '法式直角',
  '法式袖口': '法式袖口',
  '注册时间': '注册时间',
  '活动系列': '活动系列',
  '活跃': '活跃',
  '测试连接': '测试连接',
  '浏览商品': '浏览商品',
  '海军蓝人字纹': '海军蓝人字纹',
  '海量面料，一键选购': '海量面料，一键选购',
  '海鸥型': '海鸥型',
  '消息中心': '消息中心',
  '消息类型': '消息类型',
  '消息评论': '消息评论',
  '消费': '消费',
  '消费金额': '消费金额',
  '深灰': '深灰',
  '深灰大方格': '深灰大方格',
  '深藏青': '深藏青',
  '深藏青羊毛': '深藏青羊毛',
  '深藏青羊毛裙料': '深藏青羊毛裙料',
  '深藏青羊毛裤料': '深藏青羊毛裤料',
  '添加': '添加',
  '添加体型特征': '添加体型特征',
  '添加刺绣': '添加刺绣',
  '添加备注': '添加备注',
  '添加新的量体说明或客户特殊偏好...': '添加新的量体说明或客户特殊偏好...',
  '添加特体': '添加特体',
  '添加面料': '添加面料',
  '清除缓存': '清除缓存',
  '时区': '时区',
  '温莎领': '温莎领',
  '温莎领（内弧）': '温莎领（内弧）',
  '溜肩': '溜肩',
  '灰色': '灰色',
  '灰色精纺': '灰色精纺',
  '灰色里布': '灰色里布',
  '灰色防滑腰里': '灰色防滑腰里',
  '烟斗型': '烟斗型',
  '熨烫挺缝线': '熨烫挺缝线',
  '版型': '版型',
  '版型 / 款式库': '版型 / 款式库',
  '版型参数': '版型参数',
  '牛角扣': '牛角扣',
  '物料中心': '物料中心',
  '物料供应商': '物料供应商',
  '物料分类': '物料分类',
  '物料品牌': '物料品牌',
  '物料寄出': '物料寄出',
  '物料寄出管理': '物料寄出管理',
  '物料小部件': '物料小部件',
  '物料明细': '物料明细',
  '物料管理': '物料管理',
  '物料编号': '物料编号',
  '物料采购': '物料采购',
  '物流': '物流',
  '物流信息': '物流信息',
  '物流公司': '物流公司',
  '物流单号': '物流单号',
  '物流单号格式错误。': '物流单号格式错误。',
  '物流方式': '物流方式',
  '物流费': '物流费',
  '物流费用': '物流费用',
  '物流轨迹': '物流轨迹',
  '物流追踪单号': '物流追踪单号',
  '特急（5 天）': '特急（5 天）',
  '特殊纽扣': '特殊纽扣',
  '特殊要求': '特殊要求',
  '特殊设计': '特殊设计',
  '特殊设计费': '特殊设计费',
  '额外面料费': '额外面料费',
  '特殊里衬': '特殊里衬',
  '状态': '状态',
  '状态变更时间线': '状态变更时间线',
  '状态映射': '状态映射',
  '现款设计': '现款设计',
  '珍珠母贝': '珍珠母贝',
  '开始推送': '开始推送',
  '生产中': '生产中',
  '生产中数量': '生产中数量',
  '生产中订单': '生产中订单',
  '生成报价单': '生成报价单',
  '生成日期': '生成日期',
  '用户名': '用户名',
  '用户名或密码错误。': '用户名或密码错误。',
  '用户管理': '用户管理',
  '用此尺寸下单': '用此尺寸下单',
  '由于选择了重磅法兰绒面料，放松量已手动增加 0.5cm 以确保动态舒适度。': '由于选择了重磅法兰绒面料，放松量已手动增加 0.5cm 以确保动态舒适度。',
  '申请售后': '申请售后',
  '申请折扣率': '申请折扣率',
  '申请时间': '申请时间',
  '电子邮件': '电子邮件',
  '电子邮箱': '电子邮箱',
  '电话': '电话',
  '男': '男',
  '界面风格配置': '界面风格配置',
  '登出': '登出',
  '登录': '登录',
  '登录失败': '登录失败',
  '登录失败，请检查用户名和密码': '登录失败，请检查用户名和密码',
  '请输入用户名和密码': '请输入用户名和密码',
  '密码错误次数过多，账号已锁定30分钟，请稍后再试': '密码错误次数过多，账号已锁定30分钟，请稍后再试',
  '用户名或密码错误': '用户名或密码错误',
  '登录成功': '登录成功',
  '该账号无权限登录门店端': '该账号无权限登录门店端',
  '登记寄出物料': '登记寄出物料',
  '登记成功': '登记成功',
  '白色': '白色',
  '白色无防滑腰里': '白色无防滑腰里',
  '白色涤纶里布': '白色涤纶里布',
  '白色纯棉': '白色纯棉',
  '白色里布': '白色里布',
  '白色防滑腰里': '白色防滑腰里',
  '百褶裙': '百褶裙',
  '皮鞋': '皮鞋',
  '盘亏': '盘亏',
  '盘盈': '盘盈',
  '直下摆': '直下摆',
  '直属上级': '直属上级',
  '直开口': '直开口',
  '直开口+手工套结': '直开口+手工套结',
  '直挂面': '直挂面',
  '直挂面 + 小宝剑头': '直挂面 + 小宝剑头',
  '直挂面+小宝剑头': '直挂面+小宝剑头',
  '直摆': '直摆',
  '直摆+五角布贴': '直摆+五角布贴',
  '直袋': '直袋',
  '直角 1 眼 2 扣': '直角 1 眼 2 扣',
  '直角 2 眼 2 扣': '直角 2 眼 2 扣',
  '直角两用': '直角两用',
  '直角立体贴袋 + 桃型袋盖': '直角立体贴袋 + 桃型袋盖',
  '直角立体贴袋 + 直袋盖': '直角立体贴袋 + 直袋盖',
  '直角立体贴袋+桃型袋盖': '直角立体贴袋+桃型袋盖',
  '直角立体贴袋+直袋盖': '直角立体贴袋+直袋盖',
  '直贴布中褶': '直贴布中褶',
  '直贴布大褶': '直贴布大褶',
  '直贴布小褶（塔克）': '直贴布小褶（塔克）',
  '直门襟': '直门襟',
  '相同）': '相同）',
  '真丝红色': '真丝红色',
  '真丝里布': '真丝里布',
  '真实姓名': '真实姓名',
  '真袖叉': '真袖叉',
  '真袖叉圆弧翻边（4.5cm）': '真袖叉圆弧翻边（4.5cm）',
  '真袖叉圆弧翻边（7.5cm）': '真袖叉圆弧翻边（7.5cm）',
  '真袖叉直翻边（4.5cm）': '真袖叉直翻边（4.5cm）',
  '真袖叉直翻边（7.5cm）': '真袖叉直翻边（7.5cm）',
  '短款': '短款',
  '短袖': '短袖',
  '短袖假翻边': '短袖假翻边',
  '短袖内折边': '短袖内折边',
  '短裙': '短裙',
  '码': '码',
  '码标订后复势': '码标订后复势',
  '硬衬': '硬衬',
  '确定删除该记录吗？此操作不可撤销。': '确定删除该记录吗？此操作不可撤销。',
  '确定要取消此订单吗？取消后不可恢复。': '确定要取消此订单吗？取消后不可恢复。',
  '确定要取消该订单吗？取消后不可恢复。': '确定要取消该订单吗？取消后不可恢复。',
  '确定要复制此订单吗？将创建一个新订单并保留所有配置。': '确定要复制此订单吗？将创建一个新订单并保留所有配置。',
  '确认': '确认',
  '确认 & 提交': '确认 & 提交',
  '确认付款': '确认付款',
  '确认付款并审核通过': '确认付款并审核通过',
  '确认到账': '确认到账',
  '确认取消': '确认取消',
  '确认取消该订单？取消后无法恢复。': '确认取消该订单？取消后无法恢复。',
  '确认提交': '确认提交',
  '确认提成': '确认提成',
  '确认收货': '确认收货',
  '确认收货？此操作不可撤销。': '确认收货？此操作不可撤销。',
  '确认新密码': '确认新密码',
  '确认登记': '确认登记',
  '确认移除品类?': '确认移除品类?',
  '确认签收失败': '确认签收失败',
  '确认签收成功': '确认签收成功',
  '确认订单': '确认订单',
  '确认订单后，生产周期为4–6周。': '确认订单后，生产周期为4–6周。',
  '确认驳回': '确认驳回',
  '磅': '磅',
  '礼服系列': '礼服系列',
  '礼服门襟 3.5cm（4 个 STUDS）': '礼服门襟 3.5cm（4 个 STUDS）',
  '礼服门襟 3.5cm（所有都是 STUDS）': '礼服门襟 3.5cm（所有都是 STUDS）',
  '礼服门襟 3cm（4 个 STUDS）': '礼服门襟 3cm（4 个 STUDS）',
  '礼服门襟 3cm（所有都是 STUDS）': '礼服门襟 3cm（所有都是 STUDS）',
  '礼服领': '礼服领',
  '社会保险': '社会保险',
  '禁忌 / 特殊要求': '禁忌 / 特殊要求',
  '禁忌/特殊要求': '禁忌/特殊要求',
  '禁用': '禁用',
  '种': '种',
  '穿着风格偏好': '穿着风格偏好',
  '立即下单': '立即下单',
  '等': '等',
  '筛选': '筛选',
  '管理所有定制订单': '管理所有定制订单',
  '米': '米',
  '米/码': '米/码',
  '米数': '米数',
  '米色': '米色',
  '类型': '类型',
  '粘合衬厚胸衬': '粘合衬厚胸衬',
  '粘合衬薄胸衬': '粘合衬薄胸衬',
  '粘衬': '粘衬',
  '精准算料': '精准算料',
  '系统图片': '系统图片',
  '系统更新': '系统更新',
  '系统消息': '系统消息',
  '系统设置': '系统设置',
  '系统面料': '系统面料',
  '紧急': '紧急',
  '紧身': '紧身',
  '累计消费金额': '累计消费金额',
  '累计订单': '累计订单',
  '红色': '红色',
  '纽扣': '纽扣',
  '纽扣数': '纽扣数',
  '纽扣领': '纽扣领',
  '纽约旗舰店': '纽约旗舰店',
  '终端消费者': '终端消费者',
  '经典尖领': '经典尖领',
  '经典戗驳领': '经典戗驳领',
  '结束日期': '结束日期',
  '结果': '结果',
  '结算': '结算',
  '绣字内容': '绣字内容',
  '绩效': '绩效',
  '缓存已清除': '缓存已清除',
  '编号': '编号',
  '编辑': '编辑',
  '编辑价格体系': '编辑价格体系',
  '缺少客户信息': '缺少客户信息',
  '缺货': '缺货',
  '网络错误': '网络错误',
  '网络错误，请检查后端服务是否启动': '网络错误，请检查后端服务是否启动',
  '网络错误，请检查连接后重试。': '网络错误，请检查连接后重试。',
  '设计选项加载中，网络异常或加载延长，请稍后！': '设计选项加载中，网络异常或加载延长，请稍后！',
  '羊毛系列': '羊毛系列',
  '羊绒': '羊绒',
  '美元金额': '美元金额',
  '翻边': '翻边',
  '考勤扣款': '考勤扣款',
  '考核指标': '考核指标',
  '耸肩袖（标配垫肩 + 有棉条）': '耸肩袖（标配垫肩 + 有棉条）',
  '联系': '联系',
  '联系人': '联系人',
  '联系电话': '联系电话',
  '肚围': '肚围',
  '股东分红比例': '股东分红比例',
  '肥大': '肥大',
  '肩型': '肩型',
  '肩宽': '肩宽',
  '肩斜度需复核': '肩斜度需复核',
  '背带扣': '背带扣',
  '背面图': '背面图',
  '胸围': '胸围',
  '胸袋上刺绣': '胸袋上刺绣',
  '脚口': '脚口',
  '脚口型': '脚口型',
  '脚腕围': '脚腕围',
  '腰围': '腰围',
  '腰椎前凸': '腰椎前凸',
  '腰面+侧缝顺色哑光色丁 1.5cm': '腰面+侧缝顺色哑光色丁 1.5cm',
  '腰面+侧缝顺色哑光色丁 2.5cm': '腰面+侧缝顺色哑光色丁 2.5cm',
  '腰面+侧缝黑色哑光色丁 1.5cm': '腰面+侧缝黑色哑光色丁 1.5cm',
  '腰面+侧缝黑色哑光色丁 2.5cm': '腰面+侧缝黑色哑光色丁 2.5cm',
  '腰面顺色哑光色丁': '腰面顺色哑光色丁',
  '腰面黑色哑光色丁': '腰面黑色哑光色丁',
  '腰高': '腰高',
  '腰高习惯': '腰高习惯',
  '腿根围': '腿根围',
  '膝围': '膝围',
  '膝盖围': '膝盖围',
  '臀围': '臀围',
  '自动调整刺绣高度': '自动调整刺绣高度',
  '自定义': '自定义',
  '自定义部位': '自定义部位',
  '自由选择款式细节，完全个性化定制': '自由选择款式细节，完全个性化定制',
  '至少选择一个品类': '至少选择一个品类',
  '舒适': '舒适',
  '节节高升': '节节高升',
  '英寸': '英寸',
  '英尺': '英尺',
  '英文': '英文',
  '草稿': '草稿',
  '获取付款信息失败': '获取付款信息失败',
  '获取发票信息失败': '获取发票信息失败',
  '获取商品失败': '获取商品失败',
  '获取订单列表失败': '获取订单列表失败',
  '获取订单详情失败': '获取订单详情失败',
  '蓝色': '蓝色',
  '蓝色纯棉': '蓝色纯棉',
  '蓝色纯棉里布': '蓝色纯棉里布',
  '藏青里布': '藏青里布',
  '行政人员': '行政人员',
  '行政提成（元/单）': '行政提成（元/单）',
  '衣长': '衣长',
  '表袋设计': '表袋设计',
  '衬衫': '衬衫',
  '衬衫下摆造型': '衬衫下摆造型',
  '衬衫其它设计': '衬衫其它设计',
  '衬衫刺绣位置': '衬衫刺绣位置',
  '衬衫商标': '衬衫商标',
  '衬衫尺寸': '衬衫尺寸',
  '衬衫撞色': '衬衫撞色',
  '衬衫胸袋设计': '衬衫胸袋设计',
  '衬衫袖口设计': '衬衫袖口设计',
  '衬衫设计': '衬衫设计',
  '衬衫设计尺寸': '衬衫设计尺寸',
  '衬衫部位': '衬衫部位',
  '衬衫门襟设计': '衬衫门襟设计',
  '袖口': '袖口',
  '袖口款式': '袖口款式',
  '袖口钉扣线': '袖口钉扣线',
  '袖口锁眼线': '袖口锁眼线',
  '袖口高度': '袖口高度',
  '袖型': '袖型',
  '袖笼合缝': '袖笼合缝',
  '袖肥': '袖肥',
  '袖里': '袖里',
  '袖长': '袖长',
  '裙型': '裙型',
  '裙装设计尺寸': '裙装设计尺寸',
  '裙长': '裙长',
  '裤侧缝贡针': '裤侧缝贡针',
  '裤侧袋': '裤侧袋',
  '裤内长': '裤内长',
  '裤后口袋': '裤后口袋',
  '裤子刺绣位置': '裤子刺绣位置',
  '裤子尺寸': '裤子尺寸',
  '裤子撞色部位': '裤子撞色部位',
  '裤子款式习惯': '裤子款式习惯',
  '裤子订扣线': '裤子订扣线',
  '裤子订标位置': '裤子订标位置',
  '裤子贡针': '裤子贡针',
  '裤子锁眼线': '裤子锁眼线',
  '裤脚': '裤脚',
  '裤腰': '裤腰',
  '裤腰头': '裤腰头',
  '裤腰里': '裤腰里',
  '裤腰面': '裤腰面',
  '裤腰高': '裤腰高',
  '裤臀围': '裤臀围',
  '裤装设计尺寸': '裤装设计尺寸',
  '裤褶': '裤褶',
  '裤调节袢': '裤调节袢',
  '裤里位置': '裤里位置',
  '裤里布': '裤里布',
  '裤长': '裤长',
  '裤门襟': '裤门襟',
  '西装上衣': '西装上衣',
  '西裤': '西裤',
  '西裤 + 马甲': '西裤 + 马甲',
  '西裤+马甲': '西裤+马甲',
  '西裤设计': '西裤设计',
  '西裤部位': '西裤部位',
  '要求交期': '要求交期',
  '规格': '规格',
  '规格型号': '规格型号',
  '角色管理': '角色管理',
  '警戒库存': '警戒库存',
  '归档面料单价': '归档面料单价',
  '汇率': '汇率',
  '耗料量': '耗料量',
  '归档加工费': '归档加工费',
  '费用构成': '费用构成',
  '个性项收费': '个性项收费',
  '计算公式': '计算公式',
  '计费单位': '计费单位',
  '计费方式': '计费方式',
  '订单': '订单',
  '订单价格表': '订单价格表',
  '订单信息': '订单信息',
  '订单创建成功': '订单创建成功',
  '订单号': '订单号',
  '订单实时追踪': '订单实时追踪',
  '订单尺寸汇总': '订单尺寸汇总',
  '订单已创建，折扣审批已提交': '订单已创建，折扣审批已提交',
  '订单已取消': '订单已取消',
  '订单已复制': '订单已复制',
  '订单已提交': '订单已提交',
  '订单总额': '订单总额',
  '订单提交失败，请稍后重试。': '订单提交失败，请稍后重试。',
  '订单数量': '订单数量',
  '订单概要': '订单概要',
  '订单流水': '订单流水',
  '订单消耗': '订单消耗',
  '订单状态': '订单状态',
  '订单确认': '订单确认',
  '订单记录': '订单记录',
  '订单详情': '订单详情',
  '订单详情时间': '订单详情时间',
  '订单金额': '订单金额',
  '订单需求': '订单需求',
  '订单面料': '订单面料',
  '订单驳回': '订单驳回',
  '订标位置': '订标位置',
  '订标线': '订标线',
  '订标线颜色': '订标线颜色',
  '让步接收': '让步接收',
  '记录时间': '记录时间',
  '设为常用': '设为常用',
  '设置': '设置',
  '设计师评分': '设计师评分',
  '设计选项': '设计选项',
  '设计项': '设计项',
  '设计风格': '设计风格',
  '试身': '试身',
  '试身要求': '试身要求',
  '试身费': '试身费',
  '该操作当前订单状态不允许。': '该操作当前订单状态不允许。',
  '该客户有以下量体档案，请选择一项导入到订单中，或关闭弹窗跳过': '该客户有以下量体档案，请选择一项导入到订单中，或关闭弹窗跳过',
  '详情': '详情',
  '详细地址': '详细地址',
  '语言': '语言',
  '语言配置': '语言配置',
  '请从左侧选择设计项': '请从左侧选择设计项',
  '请假扣款': '请假扣款',
  '请填写售后类型和原因': '请填写售后类型和原因',
  '请填写驳回原因': '请填写驳回原因',
  '请填写驳回原因。': '请填写驳回原因。',
  '请完善信息': '请完善信息',
  '请完善必填信息': '请完善必填信息',
  '请尝试刷新页面，或联系管理员处理。': '请尝试刷新页面，或联系管理员处理。',
  '请描述售后原因': '请描述售后原因',
  '请登录您的门店账户': '请登录您的门店账户',
  '请确认所有信息后再提交。': '请确认所有信息后再提交。',
  '请确认新密码': '请确认新密码',
  '请等待管理员审批通过后，订单将继续流转。': '请等待管理员审批通过后，订单将继续流转。',
  '请输入客户姓名': '请输入客户姓名',
  '请输入密码': '请输入密码',
  '请输入当前密码': '请输入当前密码',
  '请输入折扣审批理由（必填）': '请输入折扣审批理由（必填）',
  '请输入新密码': '请输入新密码',
  '请输入消息...': '请输入消息...',
  '请输入用户名': '请输入用户名',
  '请选择': '请选择',
  '请选择时区': '请选择时区',
  '请选择一个订单复制。': '请选择一个订单复制。',
  '请选择品类': '请选择品类',
  '调价原因': '调价原因',
  '调价金额不能大于订单总额。': '调价金额不能大于订单总额。',
  '调整原因': '调整原因',
  '调整记录': '调整记录',
  '调整额度': '调整额度',
  '负责门店': '负责门店',
  '更新成功': '更新成功',
  '更新失败': '更新失败',
  '贡针位置': '贡针位置',
  '贡针针宽': '贡针针宽',
  '财务人员确认付款': '财务人员确认付款',
  '财务复核': '财务复核',
  '财务审核': '财务审核',
  '财务待确认': '财务待确认',
  '账单管理': '账单管理',
  '账号余额': '账号余额',
  '账号余额明细': '账号余额明细',
  '账号安全': '账号安全',
  '账号': '账号',
  '米兰眼': '米兰眼',
  '手工锁眼': '手工锁眼',
  '胚布试身(机器)': '胚布试身(机器)',
  '胚布试身(手工)': '胚布试身(手工)',
  '绣字': '绣字',
  '特殊里布': '特殊里布',
  '账号已锁定，请 1 小时后重试。': '账号已锁定，请 1 小时后重试。',
  '账户余额': '账户余额',
  '账户余额 (USD)': '账户余额 (USD)',
  '账户充值': '账户充值',
  '货期': '货期',
  '质检员': '质检员',
  '质检管理': '质检管理',
  '质检通过': '质检通过',
  '购买记录': '购买记录',
  '购物车': '购物车',
  '贴袋': '贴袋',
  '费用明细': '费用明细',
  '超时时间': '超时时间',
  '超过10MB限制': '超过10MB限制',
  '跟单员': '跟单员',
  '跟单提成率': '跟单提成率',
  '身高': '身高',
  '身高(cm)': '身高(cm)',
  '身高超出正常范围，请检查修改。': '身高超出正常范围，请检查修改。',
  '转移工厂': '转移工厂',
  '软衬': '软衬',
  '输入刺绣文字': '输入刺绣文字',
  '输入客户姓名': '输入客户姓名',
  '运单号': '运单号',
  '运费': '运费',
  '运输中': '运输中',
  '运输公司名称': '运输公司名称',
  '运输方式': '运输方式',
  '运输要求': '运输要求',
  '返修中': '返修中',
  '返修内容': '返修内容',
  '返修出货期': '返修出货期',
  '返修单': '返修单',
  '返修单数量': '返修单数量',
  '返修完成': '返修完成',
  '返修订单': '返修订单',
  '返回': '返回',
  '返回上一步': '返回上一步',
  '返回修改': '返回修改',
  '返回订单列表': '返回订单列表',
  '返工': '返工',
  '返现': '返现',
  '违规项数': '违规项数',
  '退出登录': '退出登录',
  '退款': '退款',
  '选择': '选择',
  '选择量体数据': '选择量体数据',
  '选择体型特征': '选择体型特征',
  '选择已有客户': '选择已有客户',
  '选择门店': '选择门店',
  '通底贴布中褶': '通底贴布中褶',
  '通底贴布大褶': '通底贴布大褶',
  '通底贴布小褶（塔克）': '通底贴布小褶（塔克）',
  '通底贴布无褶': '通底贴布无褶',
  '通档': '通档',
  '通用模版配置': '通用模版配置',
  '通知': '通知',
  '待办': '待办',
  '提醒': '提醒',
  '状态变更': '状态变更',
  '成本预警': '成本预警',
  '超时': '超时',
  '全部已读': '全部已读',
  '全部标记为已读': '全部标记为已读',
  '消息详情': '消息详情',
  '加载中': '加载中',
  '那不勒斯肩（垫肩 0.1cm + 单层棉条 + 小碎褶）': '那不勒斯肩（垫肩 0.1cm + 单层棉条 + 小碎褶）',
  '那不勒斯肩（无垫肩 + 无棉条 + 小碎褶）': '那不勒斯肩（无垫肩 + 无棉条 + 小碎褶）',
  '邮箱': '邮箱',
  '邮编': '邮编',
  '部位': '部位',
  '部分付款': '部分付款',
  '部分付款记录': '部分付款记录',
  '部分发货': '部分发货',
  '配饰': '配饰',
  '采购中': '采购中',
  '采购入库': '采购入库',
  '采购单号': '采购单号',
  '采购单状态': '采购单状态',
  '采购申请': '采购申请',
  '采购申请提交成功。': '采购申请提交成功。',
  '采购目的': '采购目的',
  '采购类型': '采购类型',
  '采购记录': '采购记录',
  '里布': '里布',
  '里布材质': '里布材质',
  '里布造型': '里布造型',
  '里袋撞色': '里袋撞色',
  '里门襟竖向刺绣': '里门襟竖向刺绣',
  '重新推送': '重新推送',
  '重置': '重置',
  '重试次数': '重试次数',
  '量体人': '量体人',
  '量体定制': '量体定制',
  '量体尺寸': '量体尺寸',
  '量体日期': '量体日期',
  '量体档案添加成功': '量体档案添加成功',
  '金属扣': '金属扣',
  '金属裤钩': '金属裤钩',
  '金额': '金额',
  '铅笔裙': '铅笔裙',
  '银色': '银色',
  '销售业绩统计': '销售业绩统计',
  '销售价格体系配置': '销售价格体系配置',
  '销售价格表': '销售价格表',
  '销售价（USD）': '销售价（USD）',
  '错缝上袖': '错缝上袖',
  '长圆头廓尔格腰头（单向）': '长圆头廓尔格腰头（单向）',
  '长圆头拉廓尔格腰头（双向）': '长圆头拉廓尔格腰头（双向）',
  '长小圆头廓尔格腰头（单向）': '长小圆头廓尔格腰头（单向）',
  '长小圆头拉廓尔格腰头（双向）': '长小圆头拉廓尔格腰头（双向）',
  '长度': '长度',
  '长款': '长款',
  '长短': '长短',
  '长短要求': '长短要求',
  '长袖': '长袖',
  '长裙': '长裙',
  '长青系列': '长青系列',
  '门幅': '门幅',
  '门店': '门店',
  '门店 ID': '门店 ID',
  '门店Logo': '门店Logo',
  '门店信息': '门店信息',
  '门店列表': '门店列表',
  '门店名称': '门店名称',
  '门店对账单': '门店对账单',
  '门店提交审核': '门店提交审核',
  '门店端': '门店端',
  '门店编号': '门店编号',
  '门店订单管理系统': '门店订单管理系统',
  '门店详情': '门店详情',
  '门襟+袋侧缝+裤侧缝贡针': '门襟+袋侧缝+裤侧缝贡针',
  '门襟+袋侧缝贡针': '门襟+袋侧缝贡针',
  '门襟扣数': '门襟扣数',
  '门襟钉扣线': '门襟钉扣线',
  '门襟锁眼线': '门襟锁眼线',
  '问题描述': '问题描述',
  '问题解决': '问题解决',
  '防静电浅色条': '防静电浅色条',
  '防静电深色条': '防静电深色条',
  '附加费用': '附加费用',
  '随时查看订单生产进度': '随时查看订单生产进度',
  '随货发': '随货发',
  '隐藏高级信息': '隐藏高级信息',
  '需修改': '需修改',
  '需处理': '需处理',
  '青果领': '青果领',
  '面料': '面料',
  '面料 D': '面料 D',
  '面料 E': '面料 E',
  '面料 F': '面料 F',
  '面料 G': '面料 G',
  '面料 H': '面料 H',
  '面料 I': '面料 I',
  '面料 J': '面料 J',
  '面料参考': '面料参考',
  '面料号': '面料号',
  '面料品牌': '面料品牌',
  '面料商城': '面料商城',
  '面料图案': '面料图案',
  '面料展示 1': '面料展示 1',
  '面料展示 2': '面料展示 2',
  '面料展示 3': '面料展示 3',
  '面料幅宽（cm）': '面料幅宽（cm）',
  '面料延展性考虑': '面料延展性考虑',
  '面料归类规则': '面料归类规则',
  '面料成本': '面料成本',
  '面料标 + 领标': '面料标 + 领标',
  '面料标+领标': '面料标+领标',
  '面料标在右': '面料标在右',
  '面料标在左': '面料标在左',
  '面料标订下里襟': '面料标订下里襟',
  '面料标订后复势': '面料标订后复势',
  '面料标订后复势+商标订下里襟': '面料标订后复势+商标订下里襟',
  '面料款式数': '面料款式数',
  '面料纹路': '面料纹路',
  '面料编号': '面料编号',
  '面料选择': '面料选择',
  '面料选择进度': '面料选择进度',
  '面料颜色': '面料颜色',
  '页面出现错误': '页面出现错误',
  '页面设置': '页面设置',
  '页面资源已更新': '页面资源已更新',
  '项': '项',
  '顺丰': '顺丰',
  '顺色无防滑腰里': '顺色无防滑腰里',
  '顺色防滑腰里': '顺色防滑腰里',
  '顺面料色': '顺面料色',
  '预估费用': '预估费用',
  '预估费用明细': '预估费用明细',
  '预计交期': '预计交期',
  '预计到达': '预计到达',
  '预计发货日期': '预计发货日期',
  '预计完成': '预计完成',
  '预计完成日期': '预计完成日期',
  '领、袖衬': '领、袖衬',
  '领围': '领围',
  '领型': '领型',
  '领型设计': '领型设计',
  '领子+驳头': '领子+驳头',
  '领子+驳头+下口袋牙边': '领子+驳头+下口袋牙边',
  '领子+驳头+下口袋牙边+外翻袖口': '领子+驳头+下口袋牙边+外翻袖口',
  '领子+驳头+下口袋牙边+胸口袋': '领子+驳头+下口袋牙边+胸口袋',
  '领尖双层订暗扣': '领尖双层订暗扣',
  '领尖小袢订暗扣': '领尖小袢订暗扣',
  '领尖款式': '领尖款式',
  '领尖订明扣': '领尖订明扣',
  '领尖长': '领尖长',
  '领带': '领带',
  '领底尼': '领底尼',
  '领座设计': '领座设计',
  '领结': '领结',
  '领针锁圆头眼': '领针锁圆头眼',
  '颜色': '颜色',
  '额外奖励': '额外奖励',
  '额外收费': '额外收费',
  '额外费用': '额外费用',
  '风格偏好': '风格偏好',
  '首扣距离': '首扣距离',
  '首页': '首页',
  '马甲': '马甲',
  '马甲下摆设计': '马甲下摆设计',
  '马甲专用料': '马甲专用料',
  '马甲侧叉': '马甲侧叉',
  '马甲口袋': '马甲口袋',
  '马甲后背腰带': '马甲后背腰带',
  '马甲后领': '马甲后领',
  '马甲商标': '马甲商标',
  '马甲尺寸': '马甲尺寸',
  '马甲设计': '马甲设计',
  '马甲设计尺寸': '马甲设计尺寸',
  '马甲贡针': '马甲贡针',
  '马甲贡针线': '马甲贡针线',
  '马甲部位': '马甲部位',
  '马甲门襟扣数': '马甲门襟扣数',
  '马甲驳头型': '马甲驳头型',
  '马甲驳头宽度': '马甲驳头宽度',
  '马蹄脚口': '马蹄脚口',
  '驳回': '驳回',
  '驳回订单': '驳回订单',
  '驳头': '驳头',
  '驳头+下口袋牙边': '驳头+下口袋牙边',
  '驳头+下口袋牙边+胸袋': '驳头+下口袋牙边+胸袋',
  '驳头型': '驳头型',
  '驳头宽': '驳头宽',
  '驳头眼配置': '驳头眼配置',
  '驳头眼锁眼线': '驳头眼锁眼线',
  '驳头眼长度': '驳头眼长度',
  '高度': '高度',
  '高端档': '高端档',
  '高端档（高）': '高端档（高）',
  '高级工艺': '高级工艺',
  '高腰': '高腰',
  '黑名单': '黑名单',
  '黑色无防滑腰里': '黑色无防滑腰里',
  '黑色里布': '黑色里布',
  '黑色防滑腰里': '黑色防滑腰里',
  '默认': '默认',
  '默认合缝上袖': '默认合缝上袖',
  '默认工厂': '默认工厂',
  '默认左驳头眼': '默认左驳头眼',
  '龙角型': '龙角型',
  '全麻衬工艺': '全麻衬工艺',
  '粘合衬工艺': '粘合衬工艺',
  '后背': '后背',
  '包装': '包装',
  '经典': '经典',
  '现代': '现代',
  '休闲': '休闲',
  '羊毛': '羊毛',
  '棉': '棉',
  '真丝': '真丝',
  '粘胶': '粘胶',
  '盖袋': '盖袋',
  '四粒扣': '四粒扣',
  '五粒扣': '五粒扣',
  '同面料': '同面料',
  '尖领': '尖领',
  '纽扣式': '纽扣式',
  '法式': '法式',
  '礼盒': '礼盒',
  '手提袋': '手提袋',
  '首字母': '首字母',
  '系统里布': '系统里布',
  '系统纽扣': '系统纽扣',
  '客供纽扣': '客供纽扣',
  '添加里布': '添加里布',
  '添加纽扣': '添加纽扣',
  '客供里布（CMT来料加工）：由客户自行提供里布，发票中里布费用为零，仅计工艺加工费。请填写每块里布的物流信息。': '客供里布（CMT来料加工）：由客户自行提供里布，发票中里布费用为零，仅计工艺加工费。请填写每块里布的物流信息。',
  '客供纽扣（CMT来料加工）：由客户自行提供纽扣，发票中纽扣费用为零，仅计工艺加工费。请填写每包纽扣的物流信息。': '客供纽扣（CMT来料加工）：由客户自行提供纽扣，发票中纽扣费用为零，仅计工艺加工费。请填写每包纽扣的物流信息。',
  '包': '包',
  '颗': '颗',
  '纹路/花色': '纹路/花色',
  '幅宽（cm）': '幅宽（cm）',
  'AI预览图生成失败': 'AI预览图生成失败',
  'AI预览图生成请求已发送': 'AI预览图生成请求已发送',
  'Logo已删除': 'Logo已删除',
  '上衣': '上衣',
  '两次密码不一致': '两次密码不一致',
  '个类型': '个类型',
  '仅复用尺寸': '仅复用尺寸',
  '保持修改并提交': '保持修改并提交',
  '保存失败': '保存失败',
  '保存客户档案': '保存客户档案',
  '保存草稿失败，无法生成AI预览图': '保存草稿失败，无法生成AI预览图',
  '修改订单': '修改订单',
  '关联订单': '关联订单',
  '付款金额': '付款金额',
  '关联发票': '关联发票',
  '暂无物流记录': '暂无物流记录',
  '入库': '入库',
  '出库': '出库',
  '单号': '单号',
  '转账方式': '转账方式',
  '创建客户失败': '创建客户失败',
  '删除失败': '删除失败',
  '删除成功': '删除成功',
  '发票文件': '发票文件',
  '发票详情': '发票详情',
  '发票金额': '发票金额',
  '基础信息': '基础信息',
  '处理中...': '处理中...',
  '客户量体档案': '客户量体档案',
  '密码至少6位': '密码至少6位',
  '对齐': '对齐',
  '已付清': '已付清',
  '已加载客户及量体数据': '已加载客户及量体数据',
  '已复用客户信息': '已复用客户信息',
  '已复用尺寸信息': '已复用尺寸信息',
  '已复用款式信息': '已复用款式信息',
  '已有账号？': '已有账号？',
  '廓形': '廓形',
  '待采面料': '待采面料',
  '按标签筛选': '按标签筛选',
  '搜索客户': '搜索客户',
  '是否将当前客户的信息和量体数据保存到客户档案？': '是否将当前客户的信息和量体数据保存到客户档案？',
  '暂无备注信息': '暂无备注信息',
  '未付金额': '未付金额',
  '付款时间': '付款时间',
  '注册': '注册',
  '注册失败': '注册失败',
  '注册成功，请等待门店管理员审核': '注册成功，请等待门店管理员审核',
  '注册账号': '注册账号',
  '物流备注': '物流备注',
  '用户名至少3位': '用户名至少3位',
  '确认删除？': '确认删除？',
  '确认密码': '确认密码',
  '立即登录': '立即登录',
  '纽扣品牌': '纽扣品牌',
  '纽扣幅宽（cm）': '纽扣幅宽（cm）',
  '纽扣纹路': '纽扣纹路',
  '纽扣编号': '纽扣编号',
  '编辑量体档案': '编辑量体档案',
  '获取发票详情失败': '获取发票详情失败',
  '获取客户尺寸失败': '获取客户尺寸失败',
  '裤子': '裤子',
  '订单已被驳回': '订单已被驳回',
  '订单量体数据': '订单量体数据',
  '设计项加载中，请稍候': '设计项加载中，请稍候',
  '该客户暂无尺寸档案': '该客户暂无尺寸档案',
  '请再次输入密码': '请再次输入密码',
  '请确认密码': '请确认密码',
  '请输入档案名称': '请输入档案名称',
  '请输入电话': '请输入电话',
  '请输入真实姓名': '请输入真实姓名',
  '请输入身高': '请输入身高',
  '请输入身高和体重': '请输入身高和体重',
  '请输入邮箱': '请输入邮箱',
  '请选择门店': '请选择门店',
  '财务人员驳回': '财务人员驳回',
  '跳过': '跳过',
  '还没有账号？': '还没有账号？',
  '选择门店并绑定账号': '选择门店并绑定账号',
  '填写信息并由业务员审核': '填写信息并由业务员审核',
  '所属业务员账号': '所属业务员账号',
  '请输入所属业务员账号': '请输入所属业务员账号',
  '请输入负责您的业务员账号': '请输入负责您的业务员账号',
  '无门店可不填，由业务员分配': '无门店可不填，由业务员分配',
  '请输入门店名称，无门店可不填': '请输入门店名称，无门店可不填',
  '注册成功，请等待业务员审核': '注册成功，请等待业务员审核',
  '邮寄面料': '邮寄面料',
  '里布品牌': '里布品牌',
  '里布幅宽（cm）': '里布幅宽（cm）',
  '里布纹路': '里布纹路',
  '里布编号': '里布编号',
  '量体档案': '量体档案',
  '量体档案更新成功': '量体档案更新成功',
  '量体档案详情': '量体档案详情',
  '门店重新提交': '门店重新提交',
  '面料物流': '面料物流',
  '驳回图片': '驳回图片',
  'No Logo': 'No Logo',
  '裙装设计': '裙装设计',
  '加载基础数据失败': '加载基础数据失败',
  '财务经理': '财务经理',
  '门店经理': '门店经理',
  '经理': '经理',
  '最终价格以发票为准': '最终价格以发票为准',
  '生产完成': '生产完成',
  '确定删除该草稿?': '确定删除该草稿?',
  '用户删除草稿': '用户删除草稿',
  '关联发票号': '关联发票号',
  '订单品类': '订单品类',
  '发票总额': '发票总额',
  '发票创建日期': '发票创建日期',
  '订单号/客户名/发票号': '订单号/客户名/发票号',
  '下单起': '下单起',
  '下单止': '下单止',
  '总订单量': '总订单量',
  '本年订单量': '本年订单量',
  '上年订单量': '上年订单量',
  '发票总金额': '发票总金额',
  '已付款总额': '已付款总额',
  '未付款总额': '未付款总额',
  '发票信息加载中，请稍后重试': '发票信息加载中，请稍后重试',
  '消费总金额': '消费总金额',
  '消费总订单量': '消费总订单量',
  '创建日期': '创建日期',
  '消费记录': '消费记录',
  '客户星级': '客户星级',
  '星级': '星级',
  '体型照片': '体型照片',
  '备注留言': '备注留言',
  '添加留言': '添加留言',
  '输入留言内容': '输入留言内容',
  '请输入留言或上传图片': '请输入留言或上传图片',
  '确定删除该留言?': '确定删除该留言?',
  '暂无留言': '暂无留言',
  '注册日期': '注册日期',
  '搜索姓名/电话/邮箱': '搜索姓名/电话/邮箱',
  '请输入地址': '请输入地址',
  '创建成功': '创建成功',
  '添加失败': '添加失败',
  '添加成功': '添加成功',
  '上传成功': '上传成功',
  '订单提醒': '订单提醒',
  '系统升级': '系统升级',
  '待办事宜': '待办事宜',
  '超时提醒': '超时提醒',
  '发票更新': '发票更新',
  '催款提醒': '催款提醒',
  '折扣消息': '折扣消息',
  '限时折扣': '限时折扣',
  '日常消息': '日常消息',
  '用户姓名': '用户姓名',
  '店铺名': '店铺名',
  '请输入您的姓名': '请输入您的姓名',
  '请输入店铺名称': '请输入店铺名称',
  '请输入用户姓名': '请输入用户姓名',
  '请输入店铺名': '请输入店铺名',
  '填写信息完成门店注册': '填写信息完成门店注册',
  '注册成功': '注册成功',
  '请妥善保存以下信息': '请妥善保存以下信息',
  '系统登录账号': '系统登录账号',
  '服务设计师': '服务设计师',
  '登录账号与门店编号相同，请使用注册时设置的密码登录': '登录账号与门店编号相同，请使用注册时设置的密码登录',
  '登录账号与门店编号相同。账号需由业务员激活后才能登录，请联系您的业务员激活': '登录账号与门店编号相同。账号需由业务员激活后才能登录，请联系您的业务员激活',
  '设计师账号不存在，请输入正确的设计师名称': '设计师账号不存在，请输入正确的设计师名称',
  '账号未激活或已被禁用，请联系设计师激活': '账号未激活或已被禁用，请联系设计师激活',
  '价格待确认，请联系设计师': '价格待确认，请联系设计师',
  '发票总额（最终金额）': '发票总额（最终金额）',
  '该订单发票金额': '该订单发票金额',
  '关联发票总金额': '关联发票总金额',
  '含该发票所有订单': '含该发票所有订单',
  '价格待确认：未设置面料价格档，当前价格仅含加工费，请设置价格档后重新计算': '价格待确认：未设置面料价格档，当前价格仅含加工费，请设置价格档后重新计算',
  '已入账': '已入账',
  '发票状态': '发票状态',
  '订单付款': '订单付款',
  '应付': '应付',
  '已付': '已付',
  '未付': '未付',
  '项目': '项目',
  '手续费': '手续费',
  '合计': '合计',
  '该订单尚未生成发票，暂无费用明细': '该订单尚未生成发票，暂无费用明细',
  '附加费用明细': '附加费用明细',
  '该订单的尺寸数据已被他人修改，请刷新页面后重试': '该订单的尺寸数据已被他人修改，请刷新页面后重试',
  '功能已更新': '功能已更新',
  '当前页面是旧版本，点击刷新即可使用最新功能（未提交的内容会自动保留）': '当前页面是旧版本，点击刷新即可使用最新功能（未提交的内容会自动保留）',
  '立即刷新': '立即刷新',
  '自动保存失败，请点「暂存」手动保存或刷新页面': '自动保存失败，请点「暂存」手动保存或刷新页面',

  // ── 注册页：业务员账号改为选填（2026-10-09）──
  '选填：知道负责您的业务员账号可填写，将由我们为您对接；留空则由客服为您分配': '选填：知道负责您的业务员账号可填写，将由我们为您对接；留空则由客服为您分配',
  '选填，请输入负责您的业务员账号': '选填，请输入负责您的业务员账号',

  // ── 注册页：客户地址 / 联系我们（2026-10-10）──
  '客户地址': '客户地址',
  '请输入客户地址': '请输入客户地址',
  '联系我们': '联系我们',

  // ── 新建/编辑订单面料选择：品牌/样本册实时搜索下拉（2026-11-03）──
  '按品牌搜索': '按品牌搜索',
  '按样本册搜索': '按样本册搜索',
};
